// Configurazione dei modelli 3D disponibili
import { getModelPath, getImagePath, getVideoPath, ASSETS_CONFIG } from './assets-config'

export const modelConfigs = {
  tutaAmianto: {
    title: 'Tuta Amianto',
    description: 'Modello 3D della tuta amianto con animazioni e controlli di movimento',
    template: (modelPath = getModelPath('tutaAmianto'), scale = '3.5 3.5 3.5', customParams = {}) => `
<!-- Overlay con pulsante di reset per il personaggio -->
<div id="overlay" style="z-index: 2">
  <img id="recenterBtn" src="${getImagePath('resetButton')}" />
</div>

<a-scene
  xrextras-gesture-detector
  landing-page
  xrextras-loading
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrextras-runtime-error
  renderer="colorManagement: true; physicallyCorrectLights: true;"
  gltf-model="dracoDecoderPath: https://www.gstatic.com/draco/versioned/decoders/1.5.7/"
  xrweb="allowedDevices: any">
  
  <!-- Assets: modello GLTF con animazioni -->
  <a-assets>
    <a-asset-item id="robot_model" src="${modelPath}"></a-asset-item>
  </a-assets>

  <!-- Camera posizionata per una buona vista del personaggio -->
  <a-camera id="camera" position="0 4 4"> </a-camera>

  <!-- Illuminazione ambientale per una buona visibilità -->
  <a-light type="ambient" intensity="0.5"></a-light>

  <!-- Personaggio principale con animazioni e controlli -->
<a-entity
    id="character"
    character-move="idleAnim: ${modelPath.includes('metal') ? '' : (customParams.idleAnim || 'Alert')}; walkAnim:  ${modelPath.includes('metal') ? 'Animation' : (customParams.walkAnim || 'Walking')}"
    character-recenter
    gltf-model="#robot_model"
    gltf-morph="morphtarget: Surprised; value: 0"
    animation-mixer="clip: ${modelPath.includes('metal') ? '' : (customParams.idleAnim || 'Alert')}; loop: repeat; crossFadeDuration: 0.4"
    scale="${scale}"
    shadow>
  </a-entity>

  <!-- Piano di terra con ombre -->
  <a-box
    id="ground"
    scale="1000 2 1000"
    position="0 -1 0"
    material="shader: shadow; transparent: true; opacity: 0.4"
    shadow>
  </a-box>
</a-scene>`
  },

  // Template generico per nuovi modelli
  generic: {
    title: 'Modello 3D',
    description: 'Modello 3D generico',
    template: (modelPath, scale = '1 1 1', position = '0 0 0', rotation = '0 0 0', envmapUrls = null, customParams = {}) => `
<a-scene
custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrextras-gesture-detector
  xrextras-loading
  renderer="colorManagement: true; physicallyCorrectLights: true;"
  gltf-model="dracoDecoderPath: https://www.gstatic.com/draco/versioned/decoders/1.5.7/"
  xrweb="disableWorldTracking: true">

  <a-assets>
    <a-asset-item id="genericModel" src="${modelPath}"></a-asset-item>
    ${envmapUrls ? `
    <!-- Cubemap per riflessioni usando direttamente le immagini -->
    <a-cubemap id="reflection">
      <img src="${envmapUrls[0] || 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/px.png'}">
      <img src="${envmapUrls[1] || 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/nx.png'}">
      <img src="${envmapUrls[2] || 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/py.png'}">
      <img src="${envmapUrls[3] || 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/ny.png'}">
      <img src="${envmapUrls[4] || 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/pz.png'}">
      <img src="${envmapUrls[5] || 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/nz.png'}">
    </a-cubemap>
    ` : ''}
  </a-assets>

  <a-camera
    id="camera"
    position="0 5 5"
    raycaster="objects: .cantap"
    cursor="fuse: false; rayOrigin: mouse;">
  </a-camera>

  ${envmapUrls ? `<a-sphere
    id="envProbe"
    visible="false"
    material="envMap:#reflection; metalness:1.0; roughness:0.0">
  </a-sphere>` : ''}

  <a-light type="ambient" intensity="${customParams.lightIntensity || '0.6'}"></a-light>
  
  <a-entity
    light="type: directional;
       intensity: ${customParams.directionalIntensity || '0.8'};
       castShadow: ${customParams.castShadow || 'true'};
       shadowMapHeight:${customParams.shadowMapHeight || '2048'};
       shadowMapWidth:${customParams.shadowMapWidth || '2048'};
       shadowCameraTop: ${customParams.shadowCameraTop || '10'};
       target: #model;"
    position="${customParams.directionalPosition || '1 4.3 2.5'}"
    xrextras-attach="target: model; offset: ${customParams.attachOffset || '1 15 3'};"
    shadow>
  </a-entity>

  <a-entity
    id="model"
    gltf-model="#genericModel"
    class="cantap"
    scale="${scale}"
    position="${position}"
    rotation="${rotation}"
    xrextras-hold-drag 
    xrextras-two-finger-rotate
    xrextras-pinch-scale
    shadow
    ${envmapUrls ? 'apply-cubemap' : ''}
    on="model-loaded: console.log('✅ Modello caricato:', this); console.log('🎬 Animazioni disponibili:', this.components['animation-mixer']); model-error: console.error('❌ Errore caricamento modello:', (event && event.detail) ? event.detail : event);">
  </a-entity>

  <a-plane id="ground" position="0 0 0" rotation="-90 0 0" width="20" height="20" material="shader: shadow" shadow></a-plane>
</a-scene>`
  },

  // Template AR generico multi-target
  genericARmulti: {
    title: 'AR Multi-Target',
    description: 'Esperienza AR con supporto per più target e video in una singola scena',
    template: (customParams = {}) => {
      const targets = customParams.targets || []
      const videos = customParams.videos || []
      return genericARmultiTemplate(targets, videos, customParams)
    }
  }
}

// Funzione helper per creare scene HTML dinamiche con caricamento asincrono
export const createSceneHtmlAsync = async (modelType, customParams = {}, experienceId = null) => {
  console.log('🎯 createSceneHtmlAsync called with:', { modelType, customParams, experienceId });

  // AUTO-RILEVAZIONE: Se modelType è genericAR ma ci sono parametri multi-target, usa genericARmulti
  if (modelType === 'genericAR') {
    const hasMultipleTargets = (customParams?.targets && (
      (Array.isArray(customParams.targets) && customParams.targets.length > 1) ||
      (typeof customParams.targets === 'string' && (customParams.targets.includes(',') || customParams.targets.includes('["')))
    )) || (customParams?.targetName && (
      (Array.isArray(customParams.targetName) && customParams.targetName.length > 1) ||
      (typeof customParams.targetName === 'string' && (
        customParams.targetName.includes(',') ||
        customParams.targetName.includes('["') ||
        customParams.targetName.includes('\\') || // Rileva escape sequences
        customParams.targetName.includes('foto-venezia2') || // Specifico per questo caso
        customParams.targetName.includes('foto-venezia3')
      ))
    ));

    const hasMultipleVideos = (customParams?.videos && (
      (Array.isArray(customParams.videos) && customParams.videos.length > 1) ||
      (typeof customParams.videos === 'string' && (
        customParams.videos.includes(',') ||
        customParams.videos.includes('["') ||
        customParams.videos.includes('\\') || // Rileva escape sequences  
        customParams.videos.includes('venezia.mp4') || // Specifico per questo caso
        customParams.videos.includes('venezia2.mp4') ||
        customParams.videos.includes('venezia3.mp4')
      ))
    ));

    if (hasMultipleTargets || hasMultipleVideos) {
      console.log('🔄 AUTO-RILEVAZIONE ASYNC: Cambiando modelType da genericAR a genericARmulti');
      console.log('📊 Motivo:', { hasMultipleTargets, hasMultipleVideos });
      console.log('🎯 Targets rilevati:', customParams?.targets || customParams?.targetName);
      console.log('📹 Videos rilevati:', customParams?.videos);

      modelType = 'genericARmulti';
    }
  }

  // Se abbiamo un experienceId, verifica se servono parametri aggiuntivi da WordPress
  if (experienceId) {
    console.log('⏳ Verificando se servono parametri aggiuntivi da WordPress per:', experienceId);
    console.log('📊 Parametri attuali:', customParams);

    // MIGLIORAMENTO: Controllo più intelligente dei parametri essenziali
    // Un parametro è considerato presente se ha un valore valido, inclusi valori "0 0 0"
    const hasModelPath = customParams.modelPath && customParams.modelPath !== '';
    const hasScale = customParams.scale !== undefined && customParams.scale !== null && customParams.scale !== '';
    const hasPosition = customParams.position !== undefined && customParams.position !== null && customParams.position !== '';
    const hasRotation = customParams.rotation !== undefined && customParams.rotation !== null && customParams.rotation !== '';
    const hasAnimation = customParams.animation !== undefined && customParams.animation !== null && customParams.animation !== '';
    const hasText = customParams.text !== undefined && customParams.text !== null && customParams.text !== '';

    // NUOVO: Controllo per QR - se abbiamo parametri di transform validi, probabilmente arriva da QR
    const hasValidTransformParams = (hasScale || hasPosition || hasRotation);
    const hasAnimationParams = (hasAnimation && customParams.listAnim) ? true : hasText;
    const isFromQR = hasValidTransformParams && hasAnimationParams;

    console.log('🔍 Controllo parametri essenziali:', {
      modelPath: hasModelPath ? '✅' : '❌',
      scale: hasScale ? '✅' : '❌',
      position: hasPosition ? '✅' : '❌',
      rotation: hasRotation ? '✅' : '❌',
      animation: hasAnimation ? '✅' : '❌',
      text: hasText ? '✅' : '❌'
    });

    console.log('🎯 Analisi origine parametri:', {
      hasValidTransformParams,
      hasAnimationParams,
      isFromQR,
      listAnimPresent: !!customParams.listAnim
    });

    // PRIORITÀ MIGLIORATA: Se sembra provenire da QR con parametri validi, usa quelli senza chiamare WordPress
    // Ma SOLO se NON abbiamo già tutti i parametri completi da WordPress
    const hasCompleteWordPressParams = hasModelPath || (hasScale && hasPosition && hasRotation && hasAnimation);

    if (isFromQR && !hasCompleteWordPressParams) {
      console.log('✅ Parametri da QR rilevati senza dati WordPress completi, skip WordPress per evitare sovrascrittura');
      console.log('🔧 ModelPath sarà generato automaticamente dal modelType durante la creazione scena');
    } else if (hasCompleteWordPressParams) {
      console.log('✅ Parametri WordPress già completi disponibili, skip chiamata aggiuntiva');
      console.log('📋 Parametri WordPress attuali:', { scale: hasScale, position: hasPosition, rotation: hasRotation, animation: hasAnimation, text: hasText });
    } else {
      console.log('🔍 Parametri mancanti, provo WordPress...');

      // Timeout per evitare attese infinite
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Timeout WordPress')), 3000) // Ridotto a 3s
      );

      try {
        // Importa dinamicamente per evitare dipendenze circolari con timeout
        const result = await Promise.race([
          (async () => {
            const { getExperienceByIdFromWordPress } = await import('./experience-navigator');
            return await getExperienceByIdFromWordPress(experienceId);
          })(),
          timeoutPromise
        ]);

        if (result && result.config && result.config.customParams) {
          console.log('✅ Parametri WordPress aggiuntivi caricati:', result.config.customParams);

          // Controlla specificatamente i parametri di posizione, scala e rotazione
          const wpParams = result.config.customParams;
          const hasWPTransform = wpParams.scale || wpParams.position || wpParams.rotation;

          if (hasWPTransform) {
            console.log('🔧 Parametri transform WordPress trovati:', {
              scale: wpParams.scale,
              position: wpParams.position,
              rotation: wpParams.rotation
            });
          }

          // Unisci i parametri, dando priorità a quelli di WordPress solo se mancanti
          customParams = {
            ...wpParams, // WordPress come base
            ...customParams // I parametri locali hanno priorità
          };
          console.log('🔧 Parametri uniti finali:', customParams);
        } else {
          console.log('ℹ️ Nessun parametro aggiuntivo da WordPress per:', experienceId);
        }
      } catch (error) {
        if (error.message === 'Timeout WordPress') {
          console.log('⏱️ Timeout WordPress dopo 3s, uso parametri esistenti');
        } else {
          console.log('ℹ️ WordPress non disponibile per parametri aggiuntivi:', error.message);

          // QR 3D MODEL: disabilita qualsiasi fallback hardcoded, usa SOLO i parametri esistenti
          if (experienceId && (modelType === 'generic' || modelType === 'undefined' || !modelType)) {
            console.log('🚫 QR 3D MODEL: nessun fallback hardcoded. Mantengo solo i parametri esistenti:', customParams);
          } else {
            // Fallback alle configurazioni hardcoded per altri casi
            console.log('🔄 Tentativo fallback alle configurazioni hardcoded...');
            try {
              const { experienceConfigs } = await import('./experience-navigator');
              const hardcodedConfig = experienceConfigs[experienceId];

              if (hardcodedConfig) {
                console.log('✅ Configurazione hardcoded trovata:', hardcodedConfig.modelType);

                // Completa i parametri mancanti con quelli hardcoded
                const updatedParams = {
                  ...customParams,
                  scale: customParams.scale || hardcodedConfig.scale,
                  position: customParams.position || hardcodedConfig.position,
                  rotation: customParams.rotation || hardcodedConfig.rotation,
                  animation: customParams.animation || hardcodedConfig.animation,
                  repeat: customParams.repeat || hardcodedConfig.repeat,
                  listAnim: customParams.listAnim || hardcodedConfig.listAnim,
                  text: customParams.text || hardcodedConfig.text,
                  modelPath: customParams.modelPath || hardcodedConfig.modelPath
                };

                console.log('🔧 Parametri completati con configurazioni hardcoded:', updatedParams);
                customParams = updatedParams;
              } else {
                console.log('⚠️ Nessuna configurazione hardcoded trovata per:', experienceId);
              }
            } catch (fallbackError) {
              console.log('❌ Errore nel fallback alle configurazioni hardcoded:', fallbackError.message);
            }
          }
        }
      }
    }
  }

  return createSceneHtml(modelType, customParams);
};

// Funzione helper per creare scene HTML dinamiche (versione sincrona per retrocompatibilità)
export const createSceneHtml = (modelType, customParams = {}) => {
  console.log('🎯 createSceneHtml called with:', { modelType, customParams });

  // AUTO-RILEVAZIONE: Se modelType è genericAR ma ci sono parametri multi-target, usa genericARmulti
  if (modelType === 'genericAR') {
    const hasMultipleTargets = (customParams?.targets && (
      (Array.isArray(customParams.targets) && customParams.targets.length > 1) ||
      (typeof customParams.targets === 'string' && (customParams.targets.includes(',') || customParams.targets.includes('["')))
    )) || (customParams?.targetName && (
      (Array.isArray(customParams.targetName) && customParams.targetName.length > 1) ||
      (typeof customParams.targetName === 'string' && (
        customParams.targetName.includes(',') ||
        customParams.targetName.includes('["') ||
        customParams.targetName.includes('\\') || // Rileva escape sequences
        customParams.targetName.includes('foto-venezia2') || // Specifico per questo caso
        customParams.targetName.includes('foto-venezia3')
      ))
    ));

    const hasMultipleVideos = (customParams?.videos && (
      (Array.isArray(customParams.videos) && customParams.videos.length > 1) ||
      (typeof customParams.videos === 'string' && (
        customParams.videos.includes(',') ||
        customParams.videos.includes('["') ||
        customParams.videos.includes('\\') || // Rileva escape sequences  
        customParams.videos.includes('venezia.mp4') || // Specifico per questo caso
        customParams.videos.includes('venezia2.mp4') ||
        customParams.videos.includes('venezia3.mp4')
      ))
    ));

    if (hasMultipleTargets || hasMultipleVideos) {
      console.log('🔄 AUTO-RILEVAZIONE: Cambiando modelType da genericAR a genericARmulti');
      console.log('📊 Motivo:', { hasMultipleTargets, hasMultipleVideos });
      console.log('🎯 Targets rilevati:', customParams?.targets || customParams?.targetName);
      console.log('📹 Videos rilevati:', customParams?.videos);

      modelType = 'genericARmulti';
    }
  }

  // Controlla se è un template AR con image targets
  if (modelType === 'imageTargetVideo') {
    const targetName = customParams.targetName || 'default-target'
    const videoName = customParams.videoName || 'default-video'
    const videoPath = customParams.videoPath || getVideoPath(videoName)

    console.log(`🎯 Creazione scena AR con image target: ${targetName}, video: ${videoName}`)
    console.log(`📹 Percorso video: ${videoPath}`)

    return imageTargetVideoTemplate(targetName, videoName, {
      videoPath: videoPath,
      cameraPosition: customParams.cameraPosition,
      lightIntensity: customParams.lightIntensity
    })
  }

  // Controlla se è il template ologramma di Filippo Nicolai
  if (modelType === 'filippoNicolaiHologram') {
    console.log(`🎭 Creazione scena ologramma Filippo Nicolai`)
    console.log(`📹 Percorso video: ${customParams.videoPath || getVideoPath('filippoNicolai')}`)
    console.log(`🖼️ Percorso immagine: ${customParams.imagePath || 'Nessuna immagine'}`)
    console.log(`📏 Scala immagine: ${customParams.imageScale || '1 1 1'}`)

    return filippoNicolaiHologramTemplate({
      videoPath: customParams.videoPath,
      cameraPosition: customParams.cameraPosition,
      lightIntensity: customParams.lightIntensity,
      imagePath: customParams.imagePath,
      imageScale: customParams.imageScale
    })
  }

  // Controlla se è il template AR di Mario Fiore
  if (modelType === 'marioFioreAR') {
    console.log(`🎭 Creazione scena AR di Mario Fiore`)
    console.log(`📹 Percorso video: ${customParams.videoPath || 'https://iscag-ei.it/wp-content/materiale/immaginianimate/video-mario-fiore.mp4'}`)
    console.log(`🖼️ Percorso immagine: ${customParams.imagePath || 'Nessuna immagine'}`)
    console.log(`📏 Scala immagine: ${customParams.imageScale || '1 1 1'}`)

    return marioFioreARTemplate({
      videoPath: customParams.videoPath,
      cameraPosition: customParams.cameraPosition,
      lightIntensity: customParams.lightIntensity,
      imagePath: customParams.imagePath,
      imageScale: customParams.imageScale
    })
  }

  // Controlla se è il template AR generico
  if (modelType === 'genericAR') {
    console.log('🔍 DEBUG customParams:', customParams)
    console.log('🔍 DEBUG customParams.targetName:', customParams?.targetName)
    console.log('🔍 DEBUG customParams.imagePath:', customParams?.imagePath)
    console.log('🔍 DEBUG customParams.thumb:', customParams?.thumb)

    const targetName = customParams?.targetName || 'default-target'
    const videoPath = customParams?.videoPath || `https://iscag-ei.it/wp-content/materiale/immaginianimate/${customParams?.videoName || 'default-video'}.mp4`

    console.log(`🎭 Creazione scena AR generica: ${targetName}`)
    console.log(`📹 Percorso video: ${videoPath}`)
    console.log(`🖼️ Percorso immagine: ${customParams?.imagePath || 'Nessuna immagine'}`)
    console.log(`�� Scala immagine: ${customParams?.imageScale || '1 1 1'}`)
    console.log(`🎮 Thumb per controlli: ${customParams?.thumb || 'Nessun thumb - autoplay'}`)

    return genericARTemplate(targetName, customParams?.videoName, {
      videoPath: videoPath,
      cameraPosition: customParams?.cameraPosition,
      lightIntensity: customParams?.lightIntensity,
      imagePath: customParams?.imagePath,
      imageScale: customParams?.imageScale,
      thumb: customParams?.thumb,
      height: customParams?.height,
      width: customParams?.width
    })
  }

  // Controlla se è il template AR generico multi-target
  if (modelType === 'genericARmulti') {
    console.log('🔍 DEBUG genericARmulti customParams:', customParams)

    // Gestione multi-target tramite array nei customParams con parsing sicuro
    let targets = []
    let videos = []
    let heights = ''
    let widths = ''

    // Parse sicuro heights e widths
    if (customParams?.heights) {
      heights = customParams.heights.toString()
    }
    if (customParams?.widths) {
      widths = customParams.widths.toString()
    }

    // Parse sicuro dei targets
    try {
      if (customParams?.targets) {
        if (Array.isArray(customParams.targets)) {
          targets = customParams.targets
        } else if (typeof customParams.targets === 'string') {
          // Pulisci la stringa da escape multipli
          let cleanTargetString = customParams.targets
            .replace(/\\{16,}"/g, '"')          // Gestisce 16+ backslash seguiti da quote
            .replace(/\\{8,}"/g, '"')           // Gestisce 8+ backslash seguiti da quote  
            .replace(/\\{4,}"/g, '"')           // Gestisce 4+ backslash seguiti da quote
            .replace(/\\\\\\\"/g, '"')          // Gestisce 3 backslash + quote
            .replace(/\\\"/g, '"')              // Gestisce 1 backslash + quote
            .replace(/\\{4,}/g, '\\')           // Normalizza backslash multipli

          // Correggi JSON incompleto
          if (cleanTargetString.startsWith('[') && !cleanTargetString.endsWith(']')) {
            cleanTargetString += ']'
          }

          console.log('🧹 Target string pulita:', cleanTargetString)
          targets = JSON.parse(cleanTargetString)
        }
      }

      // Aggiungi fallback: scansiona customParams per trovare target
      if (targets.length === 0) {
        const foundTargets = []
        Object.keys(customParams).forEach(key => {
          if (key.startsWith('foto-')) {
            // Include tutti i target foto- anche se sono null, perché potrebbero essere validi
            foundTargets.push(key)
          }
        })
        if (foundTargets.length > 0) {
          console.log('🔧 Target trovati nei customParams (includendo null):', foundTargets)
          targets = foundTargets
        }
      }

      // Fallback da targetName se targets è vuoto
      if (targets.length === 0 && customParams?.targetName) {
        if (Array.isArray(customParams.targetName)) {
          targets = customParams.targetName
        } else if (typeof customParams.targetName === 'string') {
          console.log('🔍 DEBUG targetName originale:', customParams.targetName.slice(0, 200))
          let cleanTargetName = customParams.targetName
            .replace(/\\{16,}"/g, '"')          // Gestisce 16+ backslash seguiti da quote
            .replace(/\\{8,}"/g, '"')           // Gestisce 8+ backslash seguiti da quote  
            .replace(/\\{4,}"/g, '"')           // Gestisce 4+ backslash seguiti da quote
            .replace(/\\\\\\\"/g, '"')          // Gestisce 3 backslash + quote
            .replace(/\\\"/g, '"')              // Gestisce 1 backslash + quote
            .replace(/\\{4,}/g, '\\')           // Normalizza backslash multipli
          console.log('🔍 DEBUG targetName pulito:', cleanTargetName.slice(0, 200))
          console.log('🔍 DEBUG customParams keys multitarget:', Object.keys(customParams).filter(k => /\w+\d+$/.test(k)))

          // Correggi JSON incompleto e ricostruisci array
          if (!cleanTargetName.endsWith(']')) {
            // Ricostruisci l'array completo basandosi sui nomi rilevati
            const foundTargets = []

            // RICOSTRUZIONE INTELLIGENTE UNIVERSALE: Rileva pattern base + numero
            const targetMatch = cleanTargetName.match(/["']([^"']+?)(\d+)["']?/)
            if (targetMatch) {
              const baseName = targetMatch[1] // es. "foto-venezia" o "bassorilievo-salazzari"  
              const startNum = parseInt(targetMatch[2]) // es. 1

              // Ricostruisci tipicamente 3 target (1, 2, 3)
              for (let i = 1; i <= 3; i++) {
                const targetName = baseName + i
                foundTargets.push(targetName)
              }

              console.log(`🧠 Ricostruzione intelligente: Rilevato pattern "${baseName}*", aggiunto 3 target`, foundTargets)

              // Controllo se esistono nei customParams per conferma
              const existingInParams = Object.keys(customParams).filter(key => key.startsWith(baseName))
              if (existingInParams.length > 0) {
                console.log(`✅ Confermato nei customParams: ${existingInParams.length} target esistenti`)
              }
            } else {
              // RICOSTRUZIONE GENERICA: Cerca target parziali nella stringa troncata
              const partialTargetMatch = cleanTargetName.match(/["']([^"']+)["']?/)
              if (partialTargetMatch) {
                const partialTarget = partialTargetMatch[1]
                foundTargets.push(partialTarget)
                console.log(`🧠 Ricostruzione da target parziale: "${partialTarget}"`)

                // Cerca target correlati nei customParams (stesso prefisso)
                const targetPrefix = partialTarget.split('-')[0] // es. "quadro" da "quadro-minerva"
                Object.keys(customParams).forEach(key => {
                  // Cerca altri target che iniziano con lo stesso prefisso
                  if (key.startsWith(targetPrefix + '-') && key !== partialTarget && !foundTargets.includes(key)) {
                    // Verifica che sia effettivamente un target (non un altro parametro)
                    if (key.length > targetPrefix.length + 1 && !key.includes('Path') && !key.includes('Url') && !key.includes('thumb')) {
                      foundTargets.push(key)
                      console.log(`🔍 Trovato target correlato: "${key}"`)
                    }
                  }
                })
              }

              // Fallback per pattern specifici noti (retrocompatibilità)
              if (foundTargets.length === 0) {
                if (cleanTargetName.includes('foto-venezia1')) {
                  foundTargets.push('foto-venezia1', 'foto-venezia2', 'foto-venezia3')
                  console.log('🧠 Fallback Venezia: Aggiunto tutti e 3 i target')
                } else if (cleanTargetName.includes('bassorilievo-salazzari1')) {
                  foundTargets.push('bassorilievo-salazzari1', 'bassorilievo-salazzari2', 'bassorilievo-salazzari3')
                  console.log('🧠 Fallback Salazzari: Aggiunto tutti e 3 i target')
                }
              }
            }

            // Scansiona tutti i customParams per trovare target aggiuntivi (anche se null)
            Object.keys(customParams).forEach(key => {
              // Rileva pattern generici: qualsiasi key che finisce con numero e non è già nei foundTargets
              if (/\d+$/.test(key) && !foundTargets.includes(key)) {
                // Se il basename corrisponde ai target già trovati, aggiungilo
                if (foundTargets.length > 0) {
                  const firstTargetBase = foundTargets[0].replace(/\d+$/, '')
                  if (key.startsWith(firstTargetBase)) {
                    foundTargets.push(key)
                  }
                } else {
                  // Se non ci sono target trovati ancora, aggiungi comunque
                  foundTargets.push(key)
                }
              }
            })

            // RICOSTRUZIONE AVANZATA: Se abbiamo solo 1 target ma indizi di più elementi
            if (foundTargets.length === 1) {
              const singleTarget = foundTargets[0]
              console.log(`🔍 Rilevato solo 1 target: "${singleTarget}", cerco indizi di target aggiuntivi...`)

              // Analizza se ci sono indizi di array più lunghi nelle stringhe originali
              const rawVideos = customParams?.videos || ''
              const rawThumbs = customParams?.thumbs || ''

              // Conta le virgole per stimare il numero di elementi
              const videoCommas = (rawVideos.match(/,/g) || []).length
              const thumbCommas = (rawThumbs.match(/,/g) || []).length
              const expectedElements = Math.max(videoCommas + 1, thumbCommas + 1)

              console.log(`📊 Analisi indizi: videos=${videoCommas + 1} elementi, thumbs=${thumbCommas + 1} elementi`)

              if (expectedElements > 1) {
                console.log(`🧠 RICOSTRUZIONE PATTERN-BASED per ${expectedElements} elementi`)

                // Pattern specifici basati sul primo target trovato
                if (singleTarget === 'quadro-minerva') {
                  foundTargets.push('quadro-pioniere')
                  console.log('🎯 Aggiunto quadro-pioniere basandosi su pattern quadro-minerva')
                } else if (singleTarget.includes('quadro-')) {
                  // Generico per altri pattern quadro-*
                  const baseName = singleTarget.replace('quadro-', '')
                  if (baseName === 'minerva') {
                    foundTargets.push('quadro-pioniere')
                  } else {
                    // Fallback generico per altri quadri
                    foundTargets.push('quadro-unknown')
                  }
                  console.log(`🎯 Pattern quadro-* rilevato, aggiunto target correlato`)
                }
              }
            }

            if (foundTargets.length > 0) {
              console.log('🔧 Ricostruito array targets da dati parziali:', foundTargets)
              targets = foundTargets
            } else {
              // Fallback: prova a completare il JSON
              if (cleanTargetName.startsWith('[') && !cleanTargetName.endsWith(']')) {
                cleanTargetName += ']'
              }
              console.log('🧹 TargetName string pulita:', cleanTargetName)
              targets = JSON.parse(cleanTargetName)
            }
          } else {
            if (cleanTargetName.startsWith('[') && !cleanTargetName.endsWith(']')) {
              cleanTargetName += ']'
            }
            console.log('🧹 TargetName string pulita:', cleanTargetName)
            targets = JSON.parse(cleanTargetName)
          }
        }
      }
    } catch (error) {
      console.error('❌ Errore parsing targets:', error)
      console.log('🔍 Raw targets data:', customParams?.targets)
      console.log('🔍 Raw targetName data:', customParams?.targetName)

      // Fallback intelligente: estrai target dai parametri
      const extractedTargets = []
      const paramKeys = Object.keys(customParams || {})

      // Cerca pattern "foto-venezia" nei parametri
      if (customParams?.targetName && typeof customParams.targetName === 'string') {
        if (customParams.targetName.includes('foto-venezia1')) extractedTargets.push('foto-venezia1')
      }
      if (paramKeys.some(key => key.includes('foto-venezia2'))) extractedTargets.push('foto-venezia2')
      if (paramKeys.some(key => key.includes('foto-venezia3'))) extractedTargets.push('foto-venezia3')

      if (extractedTargets.length > 0) {
        console.log('🔧 Targets estratti dal fallback:', extractedTargets)
        targets = extractedTargets
      } else {
        // Ultimo fallback
        targets = ['default-target']
      }
    }

    // Parse sicuro dei videos
    try {
      if (customParams?.videos) {
        if (Array.isArray(customParams.videos)) {
          videos = customParams.videos
        } else if (typeof customParams.videos === 'string') {
          let cleanVideoString = customParams.videos
            .replace(/\\{16,}"/g, '"')          // Gestisce 16+ backslash seguiti da quote
            .replace(/\\{8,}"/g, '"')           // Gestisce 8+ backslash seguiti da quote  
            .replace(/\\{4,}"/g, '"')           // Gestisce 4+ backslash seguiti da quote
            .replace(/\\\\\\\"/g, '"')          // Gestisce 3 backslash + quote
            .replace(/\\\"/g, '"')              // Gestisce 1 backslash + quote
            .replace(/\\{4,}/g, '\\')           // Normalizza backslash multipli

          // Correggi JSON incompleto e ricostruisci array
          if (!cleanVideoString.endsWith(']')) {
            // Ricostruisci l'array completo basandosi sui video rilevati
            const foundVideos = []
            const baseUrl = 'https://iscag-ei.it/wp-content/materiale/immaginianimate/'

            // RICOSTRUZIONE UNIVERSALE: Basata sui target ricostruiti
            if (targets && targets.length > 0) {
              targets.forEach(target => {
                // Estrai il nome del video dal target
                let videoName = target

                // Mapping specifici per pattern noti
                if (target.startsWith('foto-venezia')) {
                  videoName = target.replace('foto-', '')
                } else if (target.startsWith('bassorilievo-salazzari')) {
                  videoName = target.replace('bassorilievo-', '')
                } else if (target.startsWith('quadro-')) {
                  // Nuovo: supporto per pattern quadro-*
                  videoName = target.replace('quadro-', '')
                } else {
                  // Generico: usa il nome completo del target come nome video
                  videoName = target
                }

                // Aggiungi .mp4 se non presente
                if (!videoName.endsWith('.mp4')) {
                  videoName += '.mp4'
                }

                foundVideos.push(`${baseUrl}${videoName}`)
              })

              console.log(`🎬 Ricostruito array videos basato sui target (${targets.length}):`, foundVideos)
            } else {
              // Fallback per pattern specifici (mantengo per retrocompatibilità)
              if (cleanVideoString.includes('venezia.mp4') || targets.includes('foto-venezia1')) {
                foundVideos.push(`${baseUrl}venezia.mp4`)
              }
              if (cleanVideoString.includes('venezia2.mp4') || targets.includes('foto-venezia2')) {
                foundVideos.push(`${baseUrl}venezia2.mp4`)
              }
              if (cleanVideoString.includes('venezia3.mp4') || targets.includes('foto-venezia3')) {
                foundVideos.push(`${baseUrl}venezia3.mp4`)
              }
              if (cleanVideoString.includes('salazzari1.mp4') || targets.includes('bassorilievo-salazzari1')) {
                foundVideos.push(`${baseUrl}salazzari1.mp4`)
              }
              if (cleanVideoString.includes('salazzari2.mp4') || targets.includes('bassorilievo-salazzari2')) {
                foundVideos.push(`${baseUrl}salazzari2.mp4`)
              }
              if (cleanVideoString.includes('salazzari3.mp4') || targets.includes('bassorilievo-salazzari3')) {
                foundVideos.push(`${baseUrl}salazzari3.mp4`)
              }
            }

            if (foundVideos.length > 0) {
              console.log('🔧 Ricostruito array videos da dati parziali:', foundVideos)
              videos = foundVideos
            } else {
              // Fallback: prova a completare il JSON
              if (cleanVideoString.startsWith('[') && !cleanVideoString.endsWith(']')) {
                cleanVideoString += ']'
              }
              console.log('🧹 Video string pulita:', cleanVideoString)
              videos = JSON.parse(cleanVideoString)
            }
          } else {
            if (cleanVideoString.startsWith('[') && !cleanVideoString.endsWith(']')) {
              cleanVideoString += ']'
            }
            console.log('🧹 Video string pulita:', cleanVideoString)
            videos = JSON.parse(cleanVideoString)
          }
        }
      }

      // Fallback da videoPath se videos è vuoto
      if (videos.length === 0 && customParams?.videoPath) {
        videos = [customParams.videoPath]
      }
    } catch (error) {
      console.error('❌ Errore parsing videos:', error)
      console.log('🔍 Raw videos data:', customParams?.videos)

      // Fallback intelligente: genera video basandosi sui targets
      const fallbackVideos = []
      const baseUrl = 'https://iscag-ei.it/wp-content/materiale/immaginianimate/'

      for (const target of targets) {
        if (target === 'foto-venezia1') {
          fallbackVideos.push(`${baseUrl}venezia.mp4`)
        } else if (target === 'foto-venezia2') {
          fallbackVideos.push(`${baseUrl}venezia2.mp4`)
        } else if (target === 'foto-venezia3') {
          fallbackVideos.push(`${baseUrl}venezia3.mp4`)
        } else {
          // Per altri target, usa il videoPath di default
          fallbackVideos.push(customParams?.videoPath || `${baseUrl}default.mp4`)
        }
      }

      if (fallbackVideos.length > 0) {
        console.log('🔧 Videos generati dal fallback basandosi sui targets:', fallbackVideos)
        videos = fallbackVideos
      } else {
        // Ultimo fallback
        videos = [customParams?.videoPath || `${baseUrl}default.mp4`]
      }
    }



    // Parse sicuro dei thumbs
    let thumbs = []
    console.log('🔍 DEBUG PARSING THUMBS:')
    console.log('  - customParams?.thumbs:', customParams?.thumbs)
    console.log('  - customParams?.thumb:', customParams?.thumb) // Potrebbe essere "thumb" invece di "thumbs"
    console.log('  - Tipo thumbs:', typeof customParams?.thumbs)
    console.log('  - Tipo thumb:', typeof customParams?.thumb)

    try {
      // Prova prima "thumbs" (plurale)
      if (customParams?.thumbs) {
        if (Array.isArray(customParams.thumbs)) {
          thumbs = customParams.thumbs
          console.log('✅ Thumbs parsati da array:', thumbs)
        } else if (typeof customParams.thumbs === 'string' && customParams.thumbs.trim()) {
          console.log('🔧 Tentativo parsing JSON thumbs:', customParams.thumbs)
          thumbs = JSON.parse(customParams.thumbs)
          console.log('✅ Thumbs parsati da stringa JSON:', thumbs)
        }
      }

      // Se thumbs è vuoto, prova "thumb" (singolare) - potrebbe essere il parametro corretto
      if (thumbs.length === 0 && customParams?.thumb) {
        console.log('🔧 Fallback a parametro "thumb" (singolare):', customParams.thumb)
        if (Array.isArray(customParams.thumb)) {
          thumbs = customParams.thumb
          console.log('✅ Thumbs da "thumb" array:', thumbs)
        } else if (typeof customParams.thumb === 'string' && customParams.thumb.trim()) {
          // Pulisce la stringa thumb come facciamo per videos e targets
          let cleanThumbString = customParams.thumb
            .replace(/\\\\\\\"/g, '"')
            .replace(/\\\"/g, '"')
            .replace(/\\{4,}/g, '\\')

          console.log('🧹 Thumb string pulita:', cleanThumbString)

          if (!cleanThumbString.endsWith(']')) {
            cleanThumbString += ']'
            console.log('🔧 Aggiunta ] mancante:', cleanThumbString)
          }

          thumbs = JSON.parse(cleanThumbString)
          console.log('✅ Thumbs parsati da "thumb" string:', thumbs)
        }
      }
    } catch (error) {
      console.error('❌ Errore parsing thumbs:', error)
      console.log('🔍 Raw thumb data per debug:', {
        thumbs: customParams?.thumbs,
        thumb: customParams?.thumb
      })
      thumbs = []
    }

    // RICOSTRUZIONE INTELLIGENTE DEI THUMBS basata sui targets (come facciamo per i video)
    if (thumbs.length > 0 && thumbs.length < targets.length) {
      console.log(`🧠 RICOSTRUZIONE THUMBS: Abbiamo ${thumbs.length} thumbs ma ${targets.length} targets`)

      const baseUrl = 'https://iscag-ei.it/wp-content/materiale/immaginianimate/'
      const reconstructedThumbs = []

      targets.forEach((target, index) => {
        if (index < thumbs.length && thumbs[index]) {
          // Se esiste già un thumb per questo indice, usalo
          reconstructedThumbs.push(thumbs[index])
          console.log(`📎 Thumb ${index}: Mantengo esistente "${thumbs[index]}"`)
        } else {
          // Ricostruisci il thumb basandoti sul nome del target
          let thumbName = target

          // Pattern specifici per thumbs
          if (target.startsWith('foto-venezia')) {
            const num = target.replace('foto-venezia', '')
            thumbName = `ppvenezia${num}.png`
          } else if (target.startsWith('bassorilievo-salazzari')) {
            const num = target.replace('bassorilievo-salazzari', '')
            thumbName = `ppsalazzari${num}.png`
          } else if (target.startsWith('quadro-minerva')) {
            const num = target.replace('quadro-minerva', '')
            if (num === '1') {
              thumbName = 'ppminerva.png'
            } else if (num === '2') {
              thumbName = 'pppioniere.png' // Assumendo che il secondo sia pioniere
            } else {
              thumbName = `pp${target.replace('quadro-', '')}.png`
            }
          } else {
            // Pattern generico: pp + nome target senza prefisso
            thumbName = `pp${target.replace(/^[a-zA-Z]+-/, '')}.png`
          }

          const thumbPath = `${baseUrl}${thumbName}`
          reconstructedThumbs.push(thumbPath)
          console.log(`🔧 Thumb ${index}: Ricostruito "${thumbPath}" da target "${target}"`)
        }
      })

      thumbs = reconstructedThumbs
      console.log('✅ Array thumbs ricostruito:', thumbs)
    }

    // Assicurati che targets e videos abbiano la stessa lunghezza
    if (targets.length !== videos.length) {
      console.warn('⚠️ Mismatch tra targets e videos:', { targets: targets.length, videos: videos.length })

      // Se ci sono più targets che videos, duplica l'ultimo video
      while (videos.length < targets.length) {
        videos.push(videos[videos.length - 1] || 'https://iscag-ei.it/wp-content/materiale/immaginianimate/default.mp4')
      }

      // Se ci sono più videos che targets, tronca i videos
      if (videos.length > targets.length) {
        videos = videos.slice(0, targets.length)
      }
    }

    console.log(`🎭 Creazione scena AR multi-target: ${targets.length} targets`)
    console.log(`📹 Video: ${videos.length} video`)
    console.log('🎯 Targets processati:', targets)
    console.log('🎬 Videos processati:', videos)
    console.log('📏 Heights:', heights)
    console.log('📐 Widths:', widths)

    // Debug dettagliato per verificare la corrispondenza
    console.log('🔍 VERIFICA CORRISPONDENZA TARGET-VIDEO:')
    targets.forEach((target, index) => {
      const video = videos[index] || 'NESSUN VIDEO'
      const height = heights || '1'
      const width = widths || '1'
      console.log(`  ${index}: "${target}" → "${video}" (${width}x${height})`)
    })

    console.log('🚀 DEBUG: Chiamata genericARmultiTemplate con parametri:')
    console.log('  - targets:', targets)
    console.log('  - videos:', videos)
    console.log('  - thumbs passati:', thumbs)
    console.log('  - heights:', heights)
    console.log('  - widths:', widths)

    return genericARmultiTemplate(targets, videos, {
      cameraPosition: customParams?.cameraPosition,
      lightIntensity: customParams?.lightIntensity,
      imagePath: customParams?.imagePath,
      imageScale: customParams?.imageScale,
      heights: heights,
      widths: widths,
      thumbs: thumbs
    })
  }

  // Controlla se è il template Ologramma generico (video su piano con chromakey)
  if (modelType === 'ologramma') {
    const videoPath = customParams.videoPath || getVideoPath(customParams.videoName || 'olo-milone-aerofono')
    const cameraPosition = customParams.cameraPosition || '0 4 6'
    const planeScale = customParams.scale || '14 14 14'
    const planePosition = customParams.position || '0 0 -8'
    const chromaColor = customParams.chromaColor || '0.02 0.08 0.99'
    const groundSize = customParams.groundSize || '1000 1000'
    const riseHeight = customParams.riseHeight || '0.915'
    const autoplay = customParams.autoplay === 'false' ? false : true
    const loop = customParams.loop === 'false' ? 'false' : 'true'

    return `
<style>
#cta {
    z-index: 2;
    position: absolute;
    right: 6vh;
    left: 5.5vh;
    top: 40vh;
    font-family: Nunito,sans-serif;
    color: #fff;
    font-weight: 600;
    text-decoration: none;
    padding: .8em 1.6em;
    border-radius: 50px;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;
    background: linear-gradient(90deg,#7611b7,#c86dd7);
}
</style>

<a id="cta">Clicca qui per vedere l'ologramma</a>

<a-scene
  xrextras-gesture-detector
  landing-page
  xrextras-loading
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrextras-runtime-error
  renderer="colorManagement: true; physicallyCorrectLights: true;"
  xrweb="
    allowedDevices: any;
    defaultEnvironmentFogIntensity: 0.5; 
    defaultEnvironmentFloorColor: #FFF;
    defaultEnvironmentSkyBottomColor: #B4C4CC; 
    defaultEnvironmentSkyTopColor: #5ac8fa;
    defaultEnvironmentSkyGradientStrength: 0.5;
  ">

  <a-assets>
    <video id="alpha-video" playsinline webkit-playsinline preload="auto" crossorigin="anonymous" loop="${loop}" src="${videoPath}#t=0.001"></video>
    <img id="blobShadow" src="https://iscag-ei.it/wp-content/materiale/ologramma-milone/blob-shadow.png" crossorigin="anonymous">
  </a-assets>

  <a-camera id="camera" position="${cameraPosition}" raycaster="objects: .cantap" cursor="fuse: false; rayOrigin: mouse;"></a-camera>

  <a-light type="ambient"></a-light>

  <a-entity
    id="alphaVideo"
    class="cantap"
    custom-hold-drag="riseHeight: ${riseHeight}"
    play-video-correct="video: #alpha-video; autoplay: ${autoplay}"
    material="shader: chromakey; src: #alpha-video;  color: 0.02 0.08 0.99; threshold: 0.15; smoothness: 0.1; side: double; depthTest: true;"
    geometry="primitive: plane; height: 1; width: 1.78;"
    xrextras-two-finger-rotate
    xrextras-pinch-scale
    look-at="target: #camera; tilt: false"
    position="${planePosition}"
    scale="${planeScale}">
      <a-circle
        position="0 -4 0"
        rotation="-90 0 0"
        scale="1.5 0.6 1"
        radius="0.5"
        material="src: #blobShadow; opacity: 0.65; roughness: 0.8; metalness: 0;">
      </a-circle>
  </a-entity>

  <a-plane id="ground" rotation="-90 0 0" width="${groundSize.split(' ')[0]}" height="${groundSize.split(' ')[1]}" material="shader: shadow" shadow></a-plane>

</a-scene>

<script>
// Registra lo shader Chromakey personalizzato
AFRAME.registerShader('chromakey', {
  schema: {
    src: {type: 'map'},
    color: {type: 'vec3', default: {x: 0.02, y: 0.08, z: 0.99}},
    threshold: {type: 'number', default: 0.15},
    smoothness: {type: 'number', default: 0.1}
  },

  init: function (data) {
    // Crea una texture vuota inizialmente
    this.texture = new THREE.Texture();
    
    // Configura la texture per evitare errori WebGL
    this.texture.generateMipmaps = false; // Disabilita mipmap per video
    this.texture.minFilter = THREE.LinearFilter; // Filtro lineare per video
    this.texture.magFilter = THREE.LinearFilter;
    this.texture.format = THREE.RGBAFormat;
    this.texture.type = THREE.UnsignedByteType;
    
    // Gestisce correttamente i valori di colore RGB
    let colorValue;
    if (data.color && typeof data.color === 'object' && data.color.x !== undefined) {
      // Formato vec3: {x: 0.02, y: 0.08, z: 0.99}
      colorValue = new THREE.Vector3(data.color.x, data.color.y, data.color.z);
    } else if (data.color && typeof data.color === 'string') {
      if (data.color.includes(' ')) {
        // Formato legacy: "0.02 0.08 0.99"
        const rgbValues = data.color.split(' ').map(Number);
        if (rgbValues.length === 3 && !rgbValues.some(isNaN)) {
          colorValue = new THREE.Vector3(rgbValues[0], rgbValues[1], rgbValues[2]);
        } else {
          // Fallback se il parsing fallisce
          colorValue = new THREE.Vector3(0.02, 0.08, 0.99);
        }
      } else {
        // Formato stringa hex: "#0416fc"
        colorValue = new THREE.Color(data.color);
      }
    } else {
      // Fallback al colore blu predefinito
      colorValue = new THREE.Vector3(0.02, 0.08, 0.99);
    }
    
    this.material = new THREE.ShaderMaterial({
      uniforms: {
        src: {value: this.texture},
        color: {value: colorValue},
        threshold: {value: data.threshold || 0.15},
        smoothness: {value: data.smoothness || 0.1}
      },
      vertexShader: \`
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
      \`,
      fragmentShader: \`
        uniform sampler2D src;
        uniform vec3 color;
        uniform float threshold;
        uniform float smoothness;
        varying vec2 vUv;
        
        void main() {
          vec4 texColor = texture2D(src, vUv);
          
          // Calcola la distanza dal colore chroma
          float dist = distance(texColor.rgb, color);
          
          // Crea una transizione smooth per l'alpha
          float alpha = 1.0 - smoothstep(threshold, threshold + smoothness, dist);
          
          // Se il colore è molto vicino al chroma, rendi trasparente
          if (dist < threshold) {
            discard;
          }
          
          gl_FragColor = vec4(texColor.rgb, alpha);
        }
      \`,
      transparent: true,
      side: THREE.DoubleSide
    });
  },

  update: function (data) {
    if (data.src) {
      // Verifica che la texture sia valida prima di aggiornarla
      if (data.src && data.src.image && data.src.image.videoWidth > 0 && data.src.image.videoHeight > 0) {
        this.texture.image = data.src;
        this.texture.needsUpdate = true;
        
        // Aggiorna le dimensioni della texture
        this.texture.image = data.src;
        this.texture.image.needsUpdate = true;
        
        // Forza l'aggiornamento del materiale
        this.material.needsUpdate = true;
      } else {
        // Se la texture non è ancora pronta, aspetta
        if (data.src && data.src.addEventListener) {
          data.src.addEventListener('loadedmetadata', () => {
            if (data.src.videoWidth > 0 && data.src.videoHeight > 0) {
              this.texture.image = data.src;
              this.texture.needsUpdate = true;
              this.material.needsUpdate = true;
            }
          });
        }
      }
    }
    
    if (data.color) {
      let colorValue;
      if (typeof data.color === 'object' && data.color.x !== undefined) {
        // Formato vec3
        colorValue = new THREE.Vector3(data.color.x, data.color.y, data.color.z);
      } else if (typeof data.color === 'string') {
        if (data.color.includes(' ')) {
          // Formato legacy: "0.02 0.08 0.99"
          const rgbValues = data.color.split(' ').map(Number);
          if (rgbValues.length === 3 && !rgbValues.some(isNaN)) {
            colorValue = new THREE.Vector3(rgbValues[0], rgbValues[1], rgbValues[2]);
          } else {
            // Fallback se il parsing fallisce
            colorValue = new THREE.Vector3(0.02, 0.08, 0.99);
          }
        } else {
          // Formato stringa hex
          colorValue = new THREE.Color(data.color);
        }
      } else {
        // Fallback
        colorValue = new THREE.Vector3(0.02, 0.08, 0.99);
      }
      this.material.uniforms.color.value.copy(colorValue);
    }
    
    if (data.threshold !== undefined) {
      this.material.uniforms.threshold.value = data.threshold;
    }
    
    if (data.smoothness !== undefined) {
      this.material.uniforms.smoothness.value = data.smoothness;
    }
  }
});

// Componente play-video-correct
AFRAME.registerComponent('play-video-correct', {
  schema: {
    video: {type: 'string'},
    autoplay: {type: 'bool', default: true},
  },
  init() {
    const v = document.querySelector(this.data.video);
    const {el} = this;
    const prompt = document.getElementById('cta');
    let playing = false;

    if (!v) {
      console.error(\`Video element not found: \${this.data.video}\`);
      return;
    }

    // Nascondi l'ologramma all'inizio
    el.setAttribute('visible', 'false');

    if (this.data.autoplay) {
      v.autoplay = true;
      v.muted = true;
      v.play();
      el.setAttribute('visible', 'true');
    } else {
      prompt.addEventListener('click', () => {
        if (!playing) {
          playing = true;
          prompt.style.display = 'none';
          v.play();
          el.setAttribute('visible', 'true');
        }
      });
    }
  }
});
</script>`
  }

  // Template: scena cielo con dirigibile (Aquile) - Esperienza Sky Layer
  if (modelType === 'aquileSky') {
    const airshipModelPath = customParams.airshipModelPath || customParams.modelPath || getModelPath('aquile')
    const skyTextureUrl = customParams.skyTextureUrl || ''
    const airshipScale = customParams.airshipScale || '2 2 2'
    const airshipPosition = customParams.airshipPosition || '0 0 -5'
    const airshipRotation = customParams.airshipRotation || customParams.rotation || '0 0 0'
    const animationClip = customParams.animationClip || 'Scene'

    console.log('🦅 AQUILE SKY TEMPLATE:', {
      modelType,
      airshipModelPath,
      skyTextureUrl,
      airshipScale,
      airshipPosition,
      airshipRotation,
      animationClip
    })

    console.log('🔍 DEBUG AQUILE - Parametri da customParams:', {
      'customParams.scale': customParams.scale,
      'customParams.position': customParams.position,
      'customParams.rotation': customParams.rotation,
      'customParams.airshipScale': customParams.airshipScale,
      'customParams.airshipPosition': customParams.airshipPosition,
      'customParams.airshipRotation': customParams.airshipRotation
    })

    return `
<!-- Overlay per orientamento del dispositivo -->
<div id="orientationOverlay">
  <div id="message">
    <img src="https://iscag-ei.it/wp-content/materiale/rotate.svg" width="100px" />
    Please rotate the phone to portrait mode for a better experience.
  </div>
</div>


<!-- Debug overlay visivo -->
<div id="aquileDebugOverlay" style="
  position: fixed;
  top: 150px;
  left: 10px;
  background: rgba(0,0,0,0.8);
  color: white;
  padding: 15px;
  border-radius: 8px;
  font-family: monospace;
  font-size: 12px;
  z-index: 9999;
  max-width: 300px;
  line-height: 1.4;
  display: none;
">
  <div>🦅 AQUILE DEBUG</div>
  <div id="debugScale">Scale: --</div>
  <div id="debugPosition">Position: --</div>
  <div id="debugRotation">Rotation: --</div>
  <div id="debugModelPath">Model: --</div>
  <div id="debugSkyCoaching">Sky Coaching: --</div>
  <div id="debugLayerState">Layer State: --</div>
</div>

<!-- Overlay per puntare verso il cielo -->
<div id="skyPointingOverlay" style="display: none">
  <div id="skyMessage">
    <div style="font-size: 3em; margin-bottom: 20px;">☁️</div>
    <div class="sky-text">
      <div class="sky-text-it">Punta il dispositivo verso il cielo per vedere le aquile</div>
      <div class="sky-text-en">Point your device towards the sky to see the eagles</div>
    </div>
  </div>
</div>

<!-- Controlli UI nascosti per default -->
<div id="bottomBar" style="display: none">
  <button id="leftButton">
    <img src="https://iscag-ei.it/wp-content/materiale/triangle.svg" />
  </button>
  <button id="rightButton">
    <img src="https://iscag-ei.it/wp-content/materiale/triangle.svg" />
  </button>
</div>

<a-scene
  landing-page
  xrextras-loading
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrextras-runtime-error
  sky-coaching-overlay
  sky-recenter
  arrows-component
  renderer="colorManagement: true"
  xrlayers="cameraDirection: back;"
  device-orientation-aquile>
  
  <a-assets>
    <a-asset-item id="airship" src="${airshipModelPath}"></a-asset-item>
    ${skyTextureUrl ? `<img id="skyTexture" src="${skyTextureUrl}" />` : ''}
  </a-assets>

  <a-camera wasd-controls-enabled="false" near="0.1" position="0 0 0"></a-camera>

  <!-- Illuminazione ambiente -->
  <a-entity light="type: ambient; intensity: 1;"></a-entity>
  <a-entity
        gltf-model="#airship"
        position="${airshipPosition}"
        rotation="${airshipRotation}"
        scale="${airshipScale}"
        animation-mixer="clip: Animation; loop: repeat;">
      </a-entity>
  <!-- Sky Layer separato - sovrapposto alla camera -->
  <a-entity
    id="skyScene"
    xrlayerscene="name:sky; invertLayerMask:false; edgeSmoothness:0.6"
    sky-debug
    aquile-debug-overlay>
    
    <!-- Cielo trasparente per le aquile -->
    <a-sky material="${skyTextureUrl ? `src: #skyTexture; transparent: true; opacity: 1; fog:false;` : `transparent: true; opacity: 0; fog:false;`}"></a-sky>

    <!-- Pivot per controlli rotazione - contiene le aquile nel layer sky -->
    <a-entity id="pivot" position="0 0 0" rotation="0 0 0">
      <!-- Aquile che volano nel cielo reale - ora dentro il layer sky -->
     
    </a-entity>

    <!-- Illuminazione direzionale -->
    <a-entity
      light="
        type: directional; 
        castShadow: true; 
        color: white; 
        intensity: 0.2"
      position="5 10 7"
      rotation="45 0 45">
    </a-entity>

    <!-- Illuminazione ambiente per sky layer -->
    <a-entity light="type: ambient; intensity: 1;"></a-entity>
  </a-entity>

</a-scene>

<style>
/* Stili originali 8thwall per aquileSky */
#bottomBar {
  position: absolute;
  display: flex;
  left: 50%;
  bottom: 2.5vh;
  transform: translateX(-50%);
  gap: 20px;
  -webkit-user-select: none; /* Safari */
  user-select: none; /* Standard */
  z-index: 2;
}

#bottomBar img {
  height: 10vw;
  max-height: 50px;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  pointer-events: none;
}

#leftButton img {
  transform: rotate(-90deg);
}

#rightButton img {
  transform: rotate(90deg);
}

a-scene img {
  display: block;
}

/* remove default button styling */
button {
  all: unset;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

#orientationOverlay {
  z-index: 998;
  height: 100%;
  width: 100%;
  position: absolute;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  display: none;
  align-items: center;
  justify-content: center;
}

#message {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  left: 50%;
  color: white;
  font-family: sans-serif;
  font-size: 1.5em;
  text-align: center;
}

#message img {
  margin-bottom: 20px;
}

/* Stili per overlay cielo */
#skyPointingOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
}

#skyMessage {
  text-align: center;
  color: white;
  font-family: sans-serif;
  padding: 30px;
}

.sky-text-it {
  font-size: 1.3em;
  margin-bottom: 15px;
  font-weight: 500;
}

.sky-text-en {
  font-size: 1.1em;
  opacity: 0.8;
  font-style: italic;
}
</style>

<script>
console.log('🦅 AquileSky template loaded - components managed by registry');
</script>`
  }

  const config = modelConfigs[modelType] || modelConfigs.generic

  // Per i modelType generici, dobbiamo usare il modelPath specificato nei customParams
  // o fallback su un modello valido
  let modelPath
  if (modelType === 'generic' || !modelConfigs[modelType]) {
    // Se è generico o non esiste, usa il modelPath dai customParams o fallback
    if (customParams.modelPath) {
      modelPath = customParams.modelPath
    } else {
      // Prova a usare il modelType come nome del modello negli assets
      if (ASSETS_CONFIG.models && ASSETS_CONFIG.models[modelType]) {
        // Il modello esiste negli assets configurati
        modelPath = ASSETS_CONFIG.models[modelType]
        console.log(`✅ Modello trovato negli assets per modelType: ${modelType} -> ${modelPath}`);
      } else {
        // Se non esiste negli assets configurati, fallback a castelOggi
        console.warn(`⚠️ ModelType '${modelType}' non trovato negli assets configurati, fallback a castelOggi`);
        console.log(`🔍 Assets disponibili:`, Object.keys(ASSETS_CONFIG.models || {}));
        modelPath = getModelPath('castelOggi')
      }
    }
  } else {
    // Se esiste un modelType specifico, usa quello
    modelPath = customParams.modelPath || getModelPath(modelType)
  }

  // Estrai i parametri con valori di default INTELLIGENTI
  console.log('🔍 === DEBUG CUSTOM PARAMS ===')
  console.log('🔍 customParams:', customParams)
  console.log('🔍 customParams.scale:', customParams.scale)
  console.log('🔍 customParams.position:', customParams.position)
  console.log('🔍 customParams.rotation:', customParams.rotation)
  console.log('🔍 customParams.envmap:', customParams.envmap)
  console.log('🔍 typeof customParams.envmap:', typeof customParams.envmap)

  // MIGLIORAMENTO CRITICO: Usa i parametri da WordPress se disponibili, altrimenti undefined
  // per permettere ai template di usare i loro valori di default specifici
  // Ma rispetta sempre i valori espliciti da WordPress, anche se sono "0 0 0"
  const scale = (customParams.scale !== undefined && customParams.scale !== null && customParams.scale !== '')
    ? customParams.scale
    : undefined
  const position = (customParams.position !== undefined && customParams.position !== null && customParams.position !== '')
    ? customParams.position
    : undefined
  const rotation = (customParams.rotation !== undefined && customParams.rotation !== null && customParams.rotation !== '')
    ? customParams.rotation
    : undefined

  // LOG DEBUG per vedere se i parametri arrivano correttamente
  if (modelType === 'casteldelmonte') {
    console.log('🏰 DEBUG CASTELDELMONTE - parametri estratti:');
    console.log('  customParams.scale:', customParams.scale, typeof customParams.scale);
    console.log('  customParams.position:', customParams.position, typeof customParams.position);
    console.log('  customParams.rotation:', customParams.rotation, typeof customParams.rotation);
    console.log('  scale finale:', scale);
    console.log('  position finale:', position);
    console.log('  rotation finale:', rotation);
  }

  // VERIFICA SPECIALE: Se stiamo processando un template specifico e i parametri sono tutti undefined,
  // potrebbe essere che non sono arrivati correttamente da WordPress
  if (modelType !== 'generic' && modelType !== 'genericAR' &&
    scale === undefined && position === undefined && rotation === undefined) {
    console.warn(`⚠️ ATTENZIONE: Template specifico '${modelType}' senza parametri da WordPress!`)
    console.warn('  - Questo potrebbe indicare un problema nel passaggio dei parametri da QR')
    console.warn('  - customParams ricevuto:', customParams)
    console.warn('  - Il template userà i suoi valori di default hardcoded')
  }

  console.log('🔧 PARAMETRI DOPO ELABORAZIONE:')
  console.log('  - scale finale:', scale, '(undefined = usa default template)')
  console.log('  - position finale:', position, '(undefined = usa default template)')
  console.log('  - rotation finale:', rotation, '(undefined = usa default template)')

  // Estrai l'envmap se presente
  let envmapUrls = null
  if (customParams.envmap) {
    try {
      const parsedEnvmap = JSON.parse(customParams.envmap)
      console.log('🌍 Envmap parsato:', parsedEnvmap)

      // Se è un oggetto, convertilo in array nell'ordine corretto
      if (parsedEnvmap && typeof parsedEnvmap === 'object' && !Array.isArray(parsedEnvmap)) {
        envmapUrls = [
          parsedEnvmap.pos_x,
          parsedEnvmap.neg_x,
          parsedEnvmap.pos_y,
          parsedEnvmap.neg_y,
          parsedEnvmap.pos_z,
          parsedEnvmap.neg_z
        ]
        console.log('🌍 Envmap convertito da oggetto ad array:', envmapUrls)
      }
      // Se è già un array, usalo direttamente
      else if (Array.isArray(parsedEnvmap)) {
        envmapUrls = parsedEnvmap
        console.log('🌍 Envmap già in formato array:', envmapUrls)
      }
    } catch (error) {
      console.warn('Errore nel parsing dell\'envmap:', error)
    }
  }

  // Estrai i parametri di animazione
  const animation = customParams.animation || 'no'
  const repeat = customParams.repeat || 'no'
  let listAnim = ['Scene']
  if (customParams.listAnim) {
    // Se è già un array, usalo direttamente
    if (Array.isArray(customParams.listAnim)) {
      listAnim = customParams.listAnim
      console.log('🎭 listAnim è già un array:', listAnim)
    } else if (typeof customParams.listAnim === 'string') {
      // Se è una stringa, prova a parsarla come JSON
      try {
        const parsed = JSON.parse(customParams.listAnim)
        if (Array.isArray(parsed)) {
          listAnim = parsed
          console.log('🎭 listAnim parsato da JSON array:', listAnim)
        } else {
          console.log('🎭 listAnim parsato da JSON non è array, uso come singolo elemento:', parsed)
          listAnim = [parsed]
        }
      } catch (error) {
        console.log('🎭 Errore nel parsing JSON di listAnim, interpreto come nome singolo:', customParams.listAnim)
        // MIGLIORAMENTO: Se contiene virgole, dividilo
        if (customParams.listAnim.includes(',')) {
          listAnim = customParams.listAnim.split(',').map(name => name.trim())
          console.log('🎭 listAnim diviso per virgole:', listAnim)
        } else {
          // Fallback: crea un array con la stringa come singolo elemento
          listAnim = [customParams.listAnim]
          console.log('🎭 listAnim come singolo elemento:', listAnim)
        }
      }
    } else {
      console.warn('🎭 listAnim ha un tipo non supportato:', typeof customParams.listAnim, customParams.listAnim)
      listAnim = ['Scene'] // Fallback
    }
  }

  // MIGLIORAMENTO: Se non c'è listAnim ma ci sono nomi di animazione comuni nei parametri, rileva automaticamente
  if (listAnim.length === 1 && listAnim[0] === 'Scene') {
    const commonAnimNames = ['idle', 'walk', 'run', 'dance', 'jump', 'wave', 'talking', 'gesture', 'animation', 'anim']
    const foundAnimNames = []

    // Cerca nomi di animazione nei customParams
    Object.keys(customParams).forEach(key => {
      const value = customParams[key]
      if (typeof value === 'string') {
        commonAnimNames.forEach(animName => {
          if (value.toLowerCase().includes(animName.toLowerCase()) && !foundAnimNames.includes(value)) {
            foundAnimNames.push(value)
          }
        })
      }
    })

    if (foundAnimNames.length > 0) {
      listAnim = foundAnimNames
      console.log('🎭 Animazioni rilevate automaticamente dai parametri:', listAnim)
    }
  }
  const buttonText = customParams.text || 'Animazione'

  // DEBUG DETTAGLIATO per parametri di animazione
  console.log('🔍 DEBUG PARAMETRI ANIMAZIONE in createSceneHtml:')
  console.log('  - customParams:', customParams)
  console.log('  - animation:', animation)
  console.log('  - repeat:', repeat)
  console.log('  - listAnim originale:', customParams.listAnim)
  console.log('  - listAnim processato:', listAnim)
  console.log('  - buttonText:', buttonText)
  console.log('  - Tipo listAnim:', typeof customParams.listAnim)
  console.log('  - È array?', Array.isArray(customParams.listAnim))

  console.log(`🎯 Creazione scena per modelType: ${modelType}, modelPath: ${modelPath}`)
  if (envmapUrls) {
    console.log(`🌍 Envmap URLs:`, envmapUrls)
  }
  if (animation === 'yes') {
    console.log(`🎬 Animazioni disponibili:`, listAnim)
    console.log(`🔄 Repeat: ${repeat}`)
    console.log(`📝 Testo bottone: ${buttonText}`)
  }

  // DEBUG SPECIFICO per template con nomi specifici (es. casteldelmonte)
  if (modelType !== 'generic' && modelType !== 'genericAR') {
    console.log(`🏰 TEMPLATE SPECIFICO: ${modelType}`)
    console.log('  - Parametri che verranno passati al template:')
    console.log(`    * modelPath: ${modelPath}`)
    console.log(`    * scale: ${scale} ${scale === undefined ? '(userà default template)' : '(da WordPress)'}`)
    console.log(`    * position: ${position} ${position === undefined ? '(userà default template)' : '(da WordPress)'}`)
    console.log(`    * rotation: ${rotation} ${rotation === undefined ? '(userà default template)' : '(da WordPress)'}`)
  }

  if (typeof config.template === 'function') {
    console.log('🎯 Chiamata template function con parametri:', {
      modelPath,
      scale,
      position,
      rotation,
      hasEnvmapUrls: !!envmapUrls,
      customParamsKeys: Object.keys(customParams)
    })
    console.log('🔧 DEBUG customParams prima del template:', customParams);
    console.log('🔧 DEBUG id:', customParams.id);
    console.log('🔧 DEBUG experienceId:', customParams.experienceId);
    let sceneHtml = config.template(modelPath, scale, position, rotation, envmapUrls, customParams)

    // Aggiungi il bottone se l'animazione è abilitata (solo animation='yes')
    if (animation === 'yes') {
      console.log(`🎬 Animazione abilitata - aggiungo bottone con config:`, { listAnim, repeat, text: buttonText })
      sceneHtml = addNextButtonToScene(sceneHtml, { listAnim, repeat, text: buttonText })
    } else {
      console.log(`❌ Animazione NON abilitata - animation vale: "${animation}"`, {
        customParamsListAnim: customParams.listAnim,
        listAnim: listAnim
      })
    }

    return sceneHtml
  }

  let sceneHtml = config.template

  // Aggiungi il bottone se l'animazione è abilitata (solo animation='yes')
  if (animation === 'yes') {
    console.log(`🎬 Animazione abilitata (template non-function) - aggiungo bottone con config:`, { listAnim, repeat, text: buttonText })
    sceneHtml = addNextButtonToScene(sceneHtml, { listAnim, repeat, text: buttonText })
  } else {
    console.log(`❌ Animazione NON abilitata (template non-function) - animation vale: "${animation}"`, {
      customParamsListAnim: customParams.listAnim,
      listAnim: listAnim
    })
  }

  return sceneHtml
}

// Funzione helper per aggiungere il bottone next-button alla scena
const addNextButtonToScene = (sceneHtml, config) => {
  console.log(`🔧 addNextButtonToScene chiamata con config:`, config)
  const { listAnim, repeat, text } = config

  // DEBUG DETTAGLIATO per parametri del bottone
  console.log('🔍 DEBUG PARAMETRI BOTTONE ANIMAZIONE:')
  console.log('  - config completo:', config)
  console.log('  - listAnim estratto:', listAnim)
  console.log('  - repeat estratto:', repeat)
  console.log('  - text estratto:', text)
  console.log('  - Tipo listAnim:', typeof listAnim)
  console.log('  - È array?', Array.isArray(listAnim))
  console.log('  - Lunghezza listAnim:', listAnim ? listAnim.length : 'undefined')

  // Crea il bottone HTML esterno alla scena A-Frame
  const buttonHtml = `
  <div id="nextbutton" 
       style="
         width: 50vw;
         height: auto;
         position: absolute;
         bottom: 6vh;
         left: 25vw;
         background-color: #AD50FF;
         border: 0.2em solid white;
         text-align: center;
         color: #FFF;
         border-radius: 100px;
         z-index: 1000;
         display: block;
         cursor: pointer;
         font-family: monospace;
         font-size: 1.3em;
         padding: 10px 20px;
         box-sizing: border-box;
         user-select: none;
         pointer-events: auto;
         touch-action: manipulation;
       "
       tabindex="0"
       role="button"
       aria-label="${text}"
       title="${text}">
    ${text}
  </div>
  `

  // Aggiungi il componente next-button alla scena
  const componentScript = `
  <script>
    console.log('🔧 Registrazione componente next-button...');
    
    // Funzione per gestire il bottone di animazione
    function setupAnimationButton() {
      console.log('🎬 Setup bottone animazione...');
      
      let model = document.querySelector('#model');
      let nextButton = document.getElementById('nextbutton');
      
      // Se il bottone non è ancora nel DOM, riprova tra poco
      if (!nextButton) {
        console.log('⏳ Bottone non ancora nel DOM, riprovo tra 50ms...');
        setTimeout(setupAnimationButton, 50);
        return;
      }
      
      if (!model) {
        console.error('❌ Model non trovato!');
        console.log('🔍 Cercando alternative...');
        
        // Prova a cercare il modello con selettori alternativi
        const alternativeModel = document.querySelector('[gltf-model], [obj-model], [collada-model]');
        if (alternativeModel) {
          console.log('✅ Modello alternativo trovato:', alternativeModel);
          model = alternativeModel;
        } else {
          console.error('❌ Nessun modello 3D trovato nella scena!');
          return;
        }
      }
      
      // Se tutto è a posto, configura il bottone
      setupButtonEvents();
      
      function setupButtonEvents() {
        console.log('🎯 Model trovato:', model);
        console.log('🔘 Bottone trovato:', nextButton);
        
        // Configurazione
        const listAnim = ${JSON.stringify(listAnim)};
        const repeat = '${repeat}';
        const buttonText = '${text}';
        
        console.log('📋 Configurazione animazione:', { listAnim, repeat, buttonText });
        
        // Indice corrente dell'animazione
        let currentAnimIndex = 0;
        
        // MIGLIORAMENTO: Prova a rilevare automaticamente le animazioni disponibili nel modello
        const tryToDetectAvailableAnimations = () => {
          try {
            // Aspetta che il modello sia completamente caricato
            if (model.components && model.components['gltf-model'] && model.components['gltf-model'].model) {
              const gltfModel = model.components['gltf-model'].model;
              
              if (gltfModel.animations && gltfModel.animations.length > 0) {
                const availableAnimations = gltfModel.animations.map(anim => anim.name).filter(name => name && name.trim() !== '');
                console.log('🔍 Animazioni rilevate nel modello GLTF:', availableAnimations);
                
                // MIGLIORAMENTO CRITICO: Trova corrispondenze fuzzy per i nomi di animazione
                const findBestMatches = (requestedNames, availableNames) => {
                  const matches = [];
                  
                  requestedNames.forEach(requested => {
                    if (!requested || requested === 'Scene') return;
                    
                    // 1. Corrispondenza esatta
                    let match = availableNames.find(avail => 
                      avail.toLowerCase() === requested.toLowerCase()
                    );
                    
                    if (!match) {
                      // 2. Corrispondenza parziale (il nome richiesto è contenuto in quello disponibile)
                      match = availableNames.find(avail => 
                        avail.toLowerCase().includes(requested.toLowerCase()) ||
                        requested.toLowerCase().includes(avail.toLowerCase())
                      );
                    }
                    
                    if (!match) {
                      // 3. Corrispondenza semantica per nomi comuni
                      const semanticMapping = {
                        'idle': ['idle', 'wait', 'stand', 'rest', 'default'],
                        'walk': ['walk', 'walking', 'move', 'step', 'Animation'],
                        'run': ['run', 'running', 'sprint', 'jog'],
                        'dance': ['dance', 'dancing', 'groove'],
                        'talk': ['talk', 'talking', 'speak', 'speech'],
                        'wave': ['wave', 'hello', 'greeting', 'hi'],
                        'jump': ['jump', 'jumping', 'hop', 'leap']
                      };
                      
                      const requestedLower = requested.toLowerCase();
                      for (const [semantic, variants] of Object.entries(semanticMapping)) {
                        if (variants.some(variant => requestedLower.includes(variant))) {
                          match = availableNames.find(avail =>
                            variants.some(variant => avail.toLowerCase().includes(variant))
                          );
                          if (match) break;
                        }
                      }
                    }
                    
                    if (match) {
                      matches.push(match);
                      console.log('🎯 Mappatura animazione:', requested, '->', match);
                    } else {
                      console.warn('⚠️ Nessuna corrispondenza trovata per animazione:', requested);
                    }
                  });
                  
                  return matches.length > 0 ? matches : availableNames;
                };
                
                // Se listAnim è vuoto o contiene solo 'Scene', usa tutte le animazioni rilevate
                if (listAnim.length === 0 || (listAnim.length === 1 && listAnim[0] === 'Scene')) {
                  console.log('🎭 listAnim vuoto, uso tutte le animazioni rilevate:', availableAnimations);
                  return availableAnimations;
                }
                
                // Altrimenti, trova le migliori corrispondenze
                const bestMatches = findBestMatches(listAnim, availableAnimations);
                console.log('🎭 Migliori corrispondenze per animazioni:', {
                  richieste: listAnim,
                  disponibili: availableAnimations,
                  mappate: bestMatches
                });
                
                return bestMatches;
              }
            }
          } catch (error) {
            console.warn('🎭 Errore nel rilevamento animazioni:', error);
          }
          
          return listAnim; // Fallback alla lista originale
        };
        
        // Prova il rilevamento quando il modello è caricato
        const modelLoadListener = () => {
          console.log('🎬 Model-loaded event triggered, tentativo rilevamento animazioni...');
          const detectedAnimations = tryToDetectAvailableAnimations();
          if (detectedAnimations && detectedAnimations.length > 0) {
            const originalListAnim = [...listAnim];
            if (JSON.stringify(detectedAnimations) !== JSON.stringify(listAnim)) {
              console.log('🎭 Aggiornamento listAnim con animazioni mappate:', {
                originale: originalListAnim,
                nuova: detectedAnimations
              });
              listAnim.splice(0, listAnim.length, ...detectedAnimations);
              
              // Reset dell'indice corrente se necessario
              if (currentAnimIndex >= listAnim.length) {
                currentAnimIndex = 0;
                console.log('🔄 Reset indice animazione a 0');
              }
            } else {
              console.log('🎭 Nessun cambiamento necessario in listAnim');
            }
          } else {
            console.warn('🎭 Nessuna animazione rilevata dal modello, mantengo configurazione originale');
          }
        };
        
        // Ascolta l'evento di caricamento del modello con più eventi possibili
        model.addEventListener('model-loaded', modelLoadListener);
        model.addEventListener('object3dset', modelLoadListener); // Fallback
        
        // Controlla periodicamente se il modello è caricato (per QR che potrebbero caricare lentamente)
        let loadCheckAttempts = 0;
        const checkModelLoaded = () => {
          loadCheckAttempts++;
          console.log('🔍 Controllo caricamento modello, tentativo:', loadCheckAttempts);
          
          if (model.components && model.components['gltf-model'] && model.components['gltf-model'].model) {
            console.log('✅ Modello GLTF caricato, eseguo rilevamento animazioni');
            modelLoadListener();
          } else if (loadCheckAttempts < 10) { // Max 10 tentativi (5 secondi)
            setTimeout(checkModelLoaded, 500);
          } else {
            console.warn('⚠️ Timeout nel caricamento del modello dopo 10 tentativi');
          }
        };
        
        // Avvia il controllo periodico
        setTimeout(checkModelLoaded, 100);
        
        // Funzione per ottenere la prossima animazione
        const getNextAnimation = () => {
          if (listAnim.length === 0) {
            console.log('🎭 Nessuna animazione in listAnim, uso fallback "Scene"');
            return 'Scene';
          }
          
          const animName = listAnim[currentAnimIndex % listAnim.length];
          
          // MIGLIORAMENTO: Valida il nome dell'animazione
          if (!animName || animName.trim() === '' || animName === 'undefined' || animName === 'null') {
            console.warn('🎭 Nome animazione non valido:', animName, '- uso fallback "Scene"');
            return 'Scene';
          }
          
          console.log('🎭 Animazione selezionata:', animName, 'da lista:', listAnim);
          return animName.trim();
        };
        
        // Funzione per avviare l'animazione corrente
        const startCurrentAnimation = () => {
          const currentAnim = getNextAnimation();
          console.log('🎬 Avvio animazione:', currentAnim);
          console.log('🎭 Modello target:', model);
          console.log('🔄 Repeat mode:', repeat);
          
          // 🎵 GESTIONE AUDIO PER ANIMAZIONI
          // Variabile per l'URL dell'audio basato sull'esperienza
          let audioUrl = null;
          
          // Rileva l'esperienza corrente dal pathname o dai parametri URL
          const currentPath = window.location.pathname;
          const urlParams = new URLSearchParams(window.location.search);
          const expParam = urlParams.get('exp');
          const fullUrl = window.location.href;
          
          console.log('🔍 DEBUG AUDIO - Rilevamento esperienza completo:', { 
            currentPath, 
            expParam, 
            fullUrl,
            searchParams: urlParams.toString()
          });
          
          // Logica condizionale per i 2 audio specifici
          if (expParam === 'df' || currentPath.includes('trapa')) {
            audioUrl = 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/drill.mp3';
            console.log('🎵 DEBUG AUDIO - Audio selezionato per trapano:', audioUrl);
          } else if (expParam === 'dff' || currentPath.includes('morse')) {
            audioUrl = 'https://iscag-ei.it/wp-content/materiale/animazioni-3d/morse.mp3';
            console.log('🎵 DEBUG AUDIO - Audio selezionato per morse:', audioUrl);
          } else {
            console.log('🔇 DEBUG AUDIO - Nessun audio configurato per questa esperienza');
            console.log('🔍 DEBUG AUDIO - Parametri non corrispondenti:', {
              expParamValue: expParam,
              expParamType: typeof expParam,
              pathIncludes: {
                trapa: currentPath.includes('trapa'),
                morse: currentPath.includes('morse')
              }
            });
          }
          
          console.log('🎵 DEBUG AUDIO - AudioUrl finale:', audioUrl);
          
          try {
            // MIGLIORAMENTO: Verifica che l'animazione esista prima di avviarla
            const availableAnimations = tryToDetectAvailableAnimations();
            const animExists = availableAnimations.some(name => 
              name.toLowerCase() === currentAnim.toLowerCase()
            );
            
            if (!animExists && availableAnimations.length > 0) {
              console.warn('🎭 Animazione non trovata:', currentAnim, '- uso la prima disponibile:', availableAnimations[0]);
              currentAnim = availableAnimations[0];
            }
            
            // 🎵 RIPRODUZIONE AUDIO QUANDO INIZIA L'ANIMAZIONE
            console.log('🎵 DEBUG AUDIO - Controllo riproduzione audio, audioUrl:', audioUrl);
            if (audioUrl) {
              console.log('🎵 DEBUG AUDIO - Iniziando riproduzione audio...');
              try {
                // Crea un nuovo elemento audio se non esiste già
                let audioElement = document.getElementById('animationAudio');
                console.log('🔊 DEBUG AUDIO - Elemento audio esistente:', audioElement);
                
                if (!audioElement) {
                  audioElement = document.createElement('audio');
                  audioElement.id = 'animationAudio';
                  audioElement.preload = 'auto';
                  audioElement.crossOrigin = 'anonymous';
                  document.body.appendChild(audioElement);
                  console.log('🔊 DEBUG AUDIO - Elemento audio creato dinamicamente:', audioElement);
                } else {
                  console.log('🔊 DEBUG AUDIO - Usando elemento audio esistente');
                }
                
                // Imposta la sorgente audio e riproduci
                console.log('🎵 DEBUG AUDIO - Impostando sorgente audio:', audioUrl);
                audioElement.src = audioUrl;
                audioElement.currentTime = 0; // Riavvia dall'inizio
                
                console.log('🎵 DEBUG AUDIO - Tentativo di riproduzione...');
                audioElement.play().then(() => {
                  console.log('🎵 DEBUG AUDIO - Audio riprodotto con successo!', {
                    url: audioUrl,
                    duration: audioElement.duration,
                    volume: audioElement.volume,
                    readyState: audioElement.readyState
                  });
                }).catch(err => {
                  console.error('❌ DEBUG AUDIO - Errore riproduzione audio:', {
                    error: err.message,
                    code: err.code,
                    name: err.name,
                    audioUrl: audioUrl,
                    elementState: {
                      src: audioElement.src,
                      readyState: audioElement.readyState,
                      networkState: audioElement.networkState,
                      error: audioElement.error
                    }
                  });
                  
                  // Fallback: prova a riprodurre dopo interazione utente
                  console.log('🔄 DEBUG AUDIO - Tentativo riproduzione audio dopo click...');
                });
                
                // Eventi aggiuntivi per debug
                audioElement.addEventListener('loadstart', () => console.log('🎵 DEBUG AUDIO - loadstart'));
                audioElement.addEventListener('loadeddata', () => console.log('🎵 DEBUG AUDIO - loadeddata'));
                audioElement.addEventListener('canplay', () => console.log('🎵 DEBUG AUDIO - canplay'));
                audioElement.addEventListener('error', (e) => console.error('❌ DEBUG AUDIO - error event:', e));
                
              } catch (audioError) {
                console.error('❌ DEBUG AUDIO - Errore gestione audio:', {
                  error: audioError.message,
                  stack: audioError.stack,
                  audioUrl: audioUrl
                });
              }
            } else {
              console.log('🔇 DEBUG AUDIO - Nessun audioUrl impostato, salto riproduzione');
            }
            
            // Rimuove l'animazione corrente
            console.log('🗑️ Rimozione animazione corrente...');
            model.removeAttribute('animation-mixer');
            console.log('✅ Animazione rimossa');
            
            // Reimposta l'animazione dopo un breve delay per forzare il restart
            console.log('⏱️ Attendo 50ms per riavvio...');
            setTimeout(() => {
              console.log('🚀 Riavvio animazione:', currentAnim);
              
              try {
              model.setAttribute('animation-mixer', {
                clip: currentAnim,
                loop: repeat === 'yes' ? 'repeat' : 'once',
                crossFadeDuration: 0.4,
              });
              console.log('✅ Animazione avviata con successo');
              console.log('📊 Parametri animazione:', {
                clip: currentAnim,
                loop: repeat === 'yes' ? 'repeat' : 'once',
                crossFadeDuration: 0.4
              });
              } catch (innerError) {
                console.error('❌ Errore nell\'impostazione animation-mixer:', innerError);
                // Fallback: prova con animazione semplice
                try {
                  model.setAttribute('animation-mixer', 'clip: ' + currentAnim);
                  console.log('✅ Fallback animazione applicato');
                } catch (fallbackError) {
                  console.error('❌ Anche il fallback ha fallito:', fallbackError);
                }
              }
            }, 50);
          } catch (error) {
            console.error('❌ Errore nell\'avvio dell\'animazione:', error);
            console.error('🔍 Stack trace:', error.stack);
            console.error('🎭 Parametri problematici:', { currentAnim, repeat, model });
          }
        };
        
        // Gestione del click del bottone
        nextButton.onclick = () => {
          console.log('🖱️ Click sul bottone rilevato');
          console.log('🎯 Esperienza corrente:', window.location.pathname);
          console.log('🔘 Bottone cliccato:', nextButton.textContent);
          console.log('📋 Configurazione animazione:', { listAnim, repeat, buttonText });
          
          // Effetto click originale (cambia colore)
          nextButton.style.backgroundColor = 'white';
          nextButton.style.color = '#AD50FF';
          
          // Ripristina il colore originale dopo un breve delay
          setTimeout(() => {
            nextButton.style.backgroundColor = '#AD50FF';
            nextButton.style.color = '#FFF';
          }, 150);
          
          // Avvia l'animazione corrente
          startCurrentAnimation();
          
          // Passa alla prossima animazione se ce ne sono più di una
          if (listAnim.length > 1) {
            currentAnimIndex = (currentAnimIndex + 1) % listAnim.length;
            
            // Aggiorna il testo del bottone per mostrare la prossima animazione
            if (listAnim.length > 1) {
              const nextAnim = listAnim[currentAnimIndex % listAnim.length];
              const newText = buttonText + ' (' + nextAnim + ')';
              nextButton.textContent = newText;
              console.log('🔄 Testo bottone aggiornato:', newText);
            }
          }
        };
        
        // Aggiungi anche event listener addEventListener per maggiore compatibilità
        nextButton.addEventListener('click', (event) => {
          console.log('🎯 Click rilevato via addEventListener');
          console.log('📱 Evento click:', event);
          
          // Effetto click originale (cambia colore)
          nextButton.style.backgroundColor = 'white';
          nextButton.style.color = '#AD50FF';
          
          // Ripristina il colore originale dopo un breve delay
          setTimeout(() => {
            nextButton.style.backgroundColor = '#AD50FF';
            nextButton.style.color = '#FFF';
          }, 150);
          
          // Avvia l'animazione corrente
          startCurrentAnimation();
          
          // Passa alla prossima animazione se ce ne sono più di una
          if (listAnim.length > 1) {
            currentAnimIndex = (currentAnimIndex + 1) % listAnim.length;
            
            // Aggiorna il testo del bottone per mostrare la prossima animazione
            if (listAnim.length > 1) {
              const nextAnim = listAnim[currentAnimIndex % listAnim.length];
              const newText = buttonText + ' (' + nextAnim + ')';
              nextButton.textContent = newText;
              console.log('🔄 Testo bottone aggiornato:', newText);
            }
          }
        });
        
        // Aggiungi supporto per touch events per dispositivi mobili
        nextButton.addEventListener('touchstart', (event) => {
          console.log('📱 Touch start rilevato');
          event.preventDefault(); // Previene il comportamento predefinito
        });
        
        nextButton.addEventListener('touchend', (event) => {
          console.log('📱 Touch end rilevato');
          event.preventDefault();
          
          // Simula il click per i dispositivi touch
          nextButton.click();
        });
        
        // Test di funzionalità del bottone
        console.log('🧪 Test funzionalità bottone...');
        console.log('🔘 Bottone HTML:', nextButton.outerHTML);
        console.log('📱 Eventi registrati:', nextButton.onclick ? 'onclick' : 'NO onclick', nextButton.hasAttribute('onclick') ? 'has onclick attr' : 'NO onclick attr');
        console.log('🎯 Bottone cliccabile:', nextButton.style.pointerEvents);
        console.log('👁️ Bottone visibile:', nextButton.style.display, nextButton.style.visibility, nextButton.style.opacity);
        console.log('🔍 Proprietà CSS critiche:', {
          position: nextButton.style.position,
          zIndex: nextButton.style.zIndex,
          pointerEvents: nextButton.style.pointerEvents,
          cursor: nextButton.style.cursor
        });
        
        // Verifica che il bottone sia effettivamente cliccabile
        if (nextButton.style.pointerEvents === 'none') {
          console.warn('⚠️ ATTENZIONE: pointer-events è "none" - il bottone non sarà cliccabile!');
          nextButton.style.pointerEvents = 'auto';
          console.log('🔧 Corretto pointer-events a "auto"');
        }
        
        // Verifica che il bottone sia visibile e posizionato correttamente
        if (nextButton.style.display === 'none') {
          console.warn('⚠️ ATTENZIONE: display è "none" - il bottone non sarà visibile!');
          nextButton.style.display = 'block';
          console.log('🔧 Corretto display a "block"');
        }
        
        // Assicurati che il bottone abbia un z-index alto
        if (parseInt(nextButton.style.zIndex) < 1000) {
          console.warn('⚠️ ATTENZIONE: z-index troppo basso - il bottone potrebbe essere nascosto!');
          nextButton.style.zIndex = '1000';
          console.log('🔧 Corretto z-index a 1000');
        }
        
        // Simula un click per test
        console.log('🧪 Simulo click per test...');
        try {
          nextButton.click();
          console.log('✅ Click simulato riuscito');
        } catch (error) {
          console.error('❌ Errore nel click simulato:', error);
        }
        
        // Avvia la prima animazione all'inizializzazione se repeat è 'yes'
        if (repeat === 'yes' && listAnim.length > 0) {
          console.log('🚀 Auto-avvio animazione in 2 secondi...');
          setTimeout(() => {
            startCurrentAnimation();
          }, 2000); // Delay aumentato per permettere il caricamento completo
        }
        
        console.log('✅ Bottone animazione configurato correttamente');
        
        // Test immediato di funzionalità
        console.log('🧪 Test immediato di funzionalità...');
        console.log('🔘 Bottone finale:', nextButton.outerHTML);
        console.log('📱 Eventi registrati:', {
          onclick: !!nextButton.onclick,
          hasOnclickAttr: nextButton.hasAttribute('onclick'),
          addEventListener: true // Abbiamo aggiunto addEventListener
        });
        console.log('🎯 Proprietà critiche:', {
          pointerEvents: nextButton.style.pointerEvents,
          display: nextButton.style.display,
          zIndex: nextButton.style.zIndex,
          cursor: nextButton.style.cursor
        });
        
        // Verifica finale che il bottone sia cliccabile
        if (nextButton.style.pointerEvents === 'none') {
          console.warn('⚠️ ATTENZIONE: pointer-events è "none" - correggo...');
          nextButton.style.pointerEvents = 'auto';
        }
        
        if (nextButton.style.display === 'none') {
          console.warn('⚠️ ATTENZIONE: display è "none" - correggo...');
          nextButton.style.display = 'block';
        }
        
        // Assicurati che il bottone sia sopra tutto
        if (parseInt(nextButton.style.zIndex) < 1000) {
          console.warn('⚠️ ATTENZIONE: z-index troppo basso - correggo...');
          nextButton.style.zIndex = '1000';
        }
        
        // Test finale: verifica che il bottone sia effettivamente cliccabile
        console.log('🧪 Test finale di cliccabilità...');
        try {
          // Simula un click per verificare che tutto funzioni
          nextButton.click();
          console.log('✅ Test click simulato riuscito!');
        } catch (error) {
          console.error('❌ Errore nel test click simulato:', error);
        }
        
        console.log('🎉 Bottone completamente configurato e testato!');
      }
    }
    
    // Inizializzazione IMMEDIATA del bottone dopo la creazione
    console.log('🚀 Inizializzazione IMMEDIATA del bottone...');
    
    // Prova subito a configurare il bottone
    setupAnimationButton();
    
    // Fallback: se il bottone non è ancora nel DOM, riprova dopo un breve delay
    setTimeout(() => {
      const button = document.getElementById('nextbutton');
      if (button && !button.onclick) {
        console.log('🔄 Fallback: riprovo a configurare il bottone...');
        setupAnimationButton();
      }
    }, 100);
    
    // Fallback aggiuntivo: se dopo 1 secondo il bottone non è ancora configurato, riprova
    setTimeout(() => {
      const button = document.getElementById('nextbutton');
      if (button && !button.onclick) {
        console.log('🔄 Fallback tardivo: riprovo a configurare il bottone...');
        setupAnimationButton();
      }
    }, 1000);
    
    // SISTEMA DI AUTO-RIPARAZIONE: Se dopo 3 secondi il bottone non funziona, attiva la modalità emergenza
    setTimeout(() => {
      const button = document.getElementById('nextbutton');
      if (button && !button.onclick) {
        console.log('🚨 AUTO-RIPARAZIONE: Bottone non funzionante, attivo modalità emergenza...');
        if (typeof window.fixAnimationButton === 'function') {
          window.fixAnimationButton();
        } else {
          console.error('❌ Funzione di emergenza non disponibile!');
        }
      } else if (button && button.onclick) {
        console.log('✅ Bottone funzionante, nessuna riparazione necessaria');
      } else {
        console.error('❌ Bottone non trovato dopo 3 secondi!');
      }
    }, 3000);
    
    console.log('✅ Script bottone animazione caricato');
    
    // DEBUG: Rendi la funzione setupAnimationButton disponibile globalmente per debug
    window.setupAnimationButtonDebug = setupAnimationButton;
    console.log('🔧 Funzione debug disponibile: window.setupAnimationButtonDebug()');
    
    // DEBUG: Funzione di emergenza per configurare manualmente il bottone
    window.fixAnimationButton = function() {
      console.log('🚨 ATTIVAZIONE MODALITÀ EMERGENZA...');
      const button = document.getElementById('nextbutton');
      
      if (!button) {
        console.error('❌ Bottone non trovato!');
        return;
      }
      
      console.log('🔍 Cercando modello 3D...');
      
      // Cerca il modello con più selettori possibili
      let model = document.querySelector('#model');
      if (!model) {
        model = document.querySelector('[gltf-model]');
        console.log('🔍 Provo gltf-model...');
      }
      if (!model) {
        model = document.querySelector('[obj-model]');
        console.log('🔍 Provo obj-model...');
      }
      if (!model) {
        model = document.querySelector('[collada-model]');
        console.log('🔍 Provo collada-model...');
      }
      if (!model) {
        model = document.querySelector('a-entity[gltf-model]');
        console.log('🔍 Provo a-entity con gltf-model...');
      }
      if (!model) {
        model = document.querySelector('a-entity[obj-model]');
        console.log('🔍 Provo a-entity con obj-model...');
      }
      
      if (!model) {
        console.error('❌ Nessun modello 3D trovato!');
        console.log('🔍 Modelli disponibili nella scena:');
        console.log('a-entity:', document.querySelectorAll('a-entity'));
        console.log('gltf-model:', document.querySelectorAll('[gltf-model]'));
        console.log('obj-model:', document.querySelectorAll('[obj-model]'));
        return;
      }
      
      console.log('✅ Modello trovato:', model);
      console.log('🔧 Configurazione manuale del bottone...');
      
      // Configurazione di emergenza - prova a capire che tipo di esperienza è
      let listAnim = ['Animation']; // Default per bunker
      let repeat = 'no';
      let buttonText = 'Spara';
      
      // Prova a capire il tipo di esperienza dal testo del bottone
      if (button.textContent.includes('Avvia')) {
        listAnim = ['Scene'];
        repeat = 'yes';
        buttonText = 'Avvia Animazione';
      } else if (button.textContent.includes('Cambia')) {
        listAnim = ['Scene', 'walk'];
        repeat = 'yes';
        buttonText = 'Cambia Animazione';
      }
      
      console.log('📋 Configurazione rilevata:', { listAnim, repeat, buttonText });
      
      // Funzione per avviare l'animazione
      const startAnimation = () => {
        console.log('🎬 Avvio animazione di emergenza...');
        try {
          // Rimuovi l'animazione corrente se esiste
          if (model.hasAttribute('animation-mixer')) {
            console.log('🗑️ Rimozione animazione corrente...');
            model.removeAttribute('animation-mixer');
          }
          
          // Avvia la nuova animazione
          setTimeout(() => {
            const animName = listAnim[0]; // Usa la prima animazione disponibile
            console.log('🚀 Avvio animazione:', animName);
            
            model.setAttribute('animation-mixer', {
              clip: animName,
              loop: repeat === 'yes' ? 'repeat' : 'once',
              crossFadeDuration: 0.4,
            });
            
            console.log('✅ Animazione avviata con successo!');
            console.log('📊 Parametri:', {
              clip: animName,
              loop: repeat === 'yes' ? 'repeat' : 'once',
              crossFadeDuration: 0.4
            });
          }, 50);
        } catch (error) {
          console.error('❌ Errore animazione:', error);
          console.error('🔍 Stack trace:', error.stack);
        }
      };
      
      // Configura gli eventi
      button.onclick = () => {
        console.log('🖱️ Click rilevato (modalità emergenza)!');
        button.style.backgroundColor = 'white';
        button.style.color = '#AD50FF';
        startAnimation();
        setTimeout(() => {
          button.style.backgroundColor = '#AD50FF';
          button.style.color = '#FFF';
        }, 150);
      };
      
      // Rimuovi event listener duplicati se esistono
      button.removeEventListener('click', button.onclick);
      
      console.log('✅ Bottone configurato in modalità emergenza!');
      console.log('🔘 Prova a cliccare ora...');
      console.log('🎯 Modello target:', model);
      console.log('🎬 Animazioni disponibili:', listAnim);
    };
    
    console.log('🚨 Funzione di emergenza disponibile: window.fixAnimationButton()');
  </script>
  `

  // Inserisci il bottone e lo script prima della chiusura di </a-scene>
  const finalSceneHtml = sceneHtml.replace('</a-scene>', `${buttonHtml}${componentScript}</a-scene>`)
  console.log(`✅ addNextButtonToScene completata - bottone aggiunto con testo: "${text}"`)
  return finalSceneHtml
}

// Template per esperienze AR con image targets e video
export const imageTargetVideoTemplate = (targetName, videoName, options = {}) => {
  const videoPath = options.videoPath || `./assets/${videoName}.mp4`
  const cameraPosition = options.cameraPosition || '0 4 10'
  const lightIntensity = options.lightIntensity || '1'

  return `
<a-scene
  landing-page
  xrextras-loading
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrextras-loading
  xrweb="disableWorldTracking: true">

  <a-assets>
    <video id="video" autoplay muted crossorigin="anonymous" loop="true" src="${videoPath}"></video>
  </a-assets>
  
  <a-camera
    position="${cameraPosition}"
    raycaster="objects: .cantap"
    cursor="fuse: false; rayOrigin: mouse;">
  </a-camera>
  
  <a-light type="ambient" intensity="${lightIntensity}"></a-light>
  
  <!-- Note: "name:" must be set to the name of the image target uploaded to the 8th Wall Console -->
  <xrextras-named-image-target name="${targetName}">
    <xrextras-target-video-fade video="#video"></xrextras-target-video-fade>
  </xrextras-named-image-target>
  
</a-scene>`
}

// Template per esperienza ologramma di Filippo Nicolai
export const filippoNicolaiHologramTemplate = (options = {}) => {
  const videoPath = options.videoPath || getVideoPath('filippoNicolai')
  const cameraPosition = options.cameraPosition || '0 4 10'
  const lightIntensity = options.lightIntensity || '1'
  const imagePath = options.imagePath || null
  const imageScale = options.imageScale || '1 1 1'

  return `
<a-scene
  landing-page
  xrextras-loading
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrweb="disableWorldTracking: true">

  <a-assets>
    <video id="video" autoplay muted crossorigin="anonymous" loop="true" src="${videoPath}"></video>
    ${imagePath ? `<img id="targetImage" src="${imagePath}" crossorigin="anonymous">` : ''}
  </a-assets>
  
  <a-camera
    position="${cameraPosition}"
    raycaster="objects: .cantap"
    cursor="fuse: false; rayOrigin: mouse;">
  </a-camera>
  
  <a-light type="ambient" intensity="${lightIntensity}"></a-light>
  
  <!-- Note: "name:" must be set to the name of the image target uploaded to the 8th Wall Console -->
  <xrextras-named-image-target name="filippo-nicolai-quadro">
    <xrextras-target-video-fade video="#video"></xrextras-target-video-fade>
    
    <!-- Immagine al centro dello schermo che appare quando si incontra il target -->
    ${imagePath ? `
    <a-image 
      src="#targetImage" 
      position="0 0 -1" 
      scale="${imageScale}"
      class="target-image"
      visible="true">
    </a-image>
    ` : ''}
  </xrextras-named-image-target>
  
</a-scene>`
}

// Template per esperienza AR di Mario Fiore
export const marioFioreARTemplate = (options = {}) => {
  const videoPath = options.videoPath || 'https://iscag-ei.it/wp-content/materiale/immaginianimate/video-mario-fiore.mp4'
  const cameraPosition = options.cameraPosition || '0 4 10'
  const lightIntensity = options.lightIntensity || '1'
  const imagePath = options.imagePath || null
  const imageScale = options.imageScale || '1 1 1'

  return `
<a-scene
  landing-page
  xrextras-loading
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrweb="disableWorldTracking: true">

  <a-assets>
    <video id="video" autoplay muted crossorigin="anonymous" loop="true" src="${videoPath}"></video>
    ${imagePath ? `<img id="targetImage" src="${imagePath}" crossorigin="anonymous">` : ''}
  </a-assets>
  
  <a-camera
    position="${cameraPosition}"
    raycaster="objects: .cantap"
    cursor="fuse: false; rayOrigin: mouse;">
  </a-camera>
  
  <a-light type="ambient" intensity="${lightIntensity}"></a-light>
  
  <!-- Note: "name:" must be set to the name of the image target uploaded to the 8th Wall Console -->
  <xrextras-named-image-target name="mario-fiore">
    <xrextras-target-video-fade video="#video"></xrextras-target-video-fade>
    
    <!-- Immagine al centro dello schermo che appare quando si incontra il target -->
    ${imagePath ? `
    <a-image 
      src="#targetImage" 
      position="0 0 -1" 
      scale="${imageScale}"
      class="target-image"
      visible="true">
    </a-image>
    ` : ''}
  </xrextras-named-image-target>
  
</a-scene>`
}

// Template per esperienza AR generica
export const genericARTemplate = (targetName, videoName, options = {}) => {
  const videoPath = options.videoPath || `https://iscag-ei.it/wp-content/materiale/immaginianimate/${videoName}.mp4`
  const cameraPosition = options.cameraPosition || '0 4 10'
  const lightIntensity = options.lightIntensity || '1'
  const imagePath = options.imagePath || null
  const imageScale = options.imageScale || '1 1 1'

  // Check for thumb parameter to enable play/pause functionality
  const thumbPath = options.thumb || null
  const videoHeight = options.height || '1'
  const videoWidth = options.width || '1'

  return `
    <!-- Immagine al centro dello schermo che appare quando si incontra il target -->
    ${imagePath ? `
    <div 
      id="targetImageOverlay"
      class="target-image-overlay"
      style="
        position: fixed; 
        top: 50%; 
        left: 50%; 
        transform: translate(-50%, -50%); 
        width: 90vw; 
        height: auto; 
        max-width: none;
        z-index: 1000;
        display: block;
        pointer-events: none;
        -webkit-transform: translate(-50%, -50%);
        -webkit-user-select: none;
        -webkit-touch-callout: none;
      ">
      <img 
        src="${imagePath}" 
        style="
          width: 100%; 
          height: auto; 
          display: block;
          -webkit-user-select: none;
          -webkit-touch-callout: none;
        "
        crossorigin="anonymous"
        alt="Target Image">
    </div>
    ` : ''}

    <script>
  // Gestione sincronizzazione immagine/video basata su eventi 8th Wall
  ${imagePath ? `

  let isSyncInitialized = false;

  // Funzione per inizializzare la sincronizzazione
  function initializeImageSync() {
    if (isSyncInitialized) return;
    
    const targetImageOverlay = document.getElementById('targetImageOverlay');
    const scene = document.querySelector('a-scene');
    const video = document.querySelector('#video');
    
    if (!targetImageOverlay || !scene) {
      setTimeout(initializeImageSync, 500);
      return;
    }
    
    isSyncInitialized = true;
    
    // Funzione per nascondere l'immagine e la figura di scan
    const hideImage = () => {
      targetImageOverlay.style.display = 'none';
      
      // Cerca e nascondi anche eventuali elementi di scan
      const scanElements = document.querySelectorAll('.scan-figure, .figura-scan, [id*="scan"], [class*="scan"]');
      scanElements.forEach(element => {
        if (element && element.style) {
          element.style.display = 'none';
          element.style.visibility = 'hidden';
          element.style.opacity = '0';
        }
      });
    };
    
    // Funzione per mostrare l'immagine e la figura di scan
    const showImage = () => {
      targetImageOverlay.style.display = 'block';
      
      // Cerca e mostra anche eventuali elementi di scan
      const scanElements = document.querySelectorAll('.scan-figure, .figura-scan, [id*="scan"], [class*="scan"]');
      scanElements.forEach(element => {
        if (element && element.style) {
          element.style.display = 'block';
          element.style.visibility = 'visible';
          element.style.opacity = '1';
        }
      });
    };
    
    // Variabile di stato globale
    let found = [];
    let videoPlaying = false;
    
    // Eventi per aggiornare la lista dei target trovati
    scene.addEventListener('xrimagefound', ({detail}) => {
      if (!found.includes(detail.name)) {
        found.push(detail.name);
      }
      
      // Se almeno un marker è trovato, nascondi l'immagine
      if (found.length > 0) {
        hideImage();
      }
    });

    scene.addEventListener('xrimagelost', ({detail}) => {
      const index = found.indexOf(detail.name);
      if (index !== -1) {
        found.splice(index, 1);
      }
      
      // Se non ci sono più marker trovati, mostra l'immagine
      if (found.length === 0 && !videoPlaying) {
        showImage();
      }
    });
    
    // Eventi per il video
    if (video) {
      // Eventi standard del video
      video.addEventListener('play', () => {
        console.log('▶️ Video play');
        videoPlaying = true;
        hideImage();
      });
      
      video.addEventListener('playing', () => {
        console.log('▶️ Video playing');
        videoPlaying = true;
        hideImage();
      });
      
      video.addEventListener('pause', () => {
        console.log('⏸️ Video pause');
        videoPlaying = false;
        if (found.length === 0) {
          showImage();
        }
      });
      
      video.addEventListener('ended', () => {
        console.log('⏹️ Video ended');
        videoPlaying = false;
        if (found.length === 0) {
          showImage();
        }
      });
      
      // Eventi specifici 8th Wall per il video
      video.addEventListener('xrextras-video-fade-in', () => {
        videoPlaying = true;
        hideImage();
      });
      
      video.addEventListener('xrextras-video-fade-out', () => {
        videoPlaying = false;
        if (found.length === 0) {
          showImage();
        }
      });
      
      // Controllo iniziale - mostra l'immagine all'inizio
      showImage();
    }
    
    // Controllo periodico del ricaricamento overlay (safety override se gli eventi si perdono)
    setInterval(() => {
      const scanImage = document.getElementById('targetImageOverlay');
      if (found.length === 0 && !videoPlaying) {
        const scanVisible = scanImage ? scanImage.style.display !== 'none' : false;
        if (!scanVisible) {
          showImage();
        }
      } else if (found.length > 0) {
        const scanVisible = scanImage ? scanImage.style.display !== 'none' : false;
        if (scanVisible) {
          hideImage();
        }
      }
    }, 200);
  }
  
  // Inizializzazione con retry
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initializeImageSync, 1000);
  });
  
  // Backup: inizializzazione quando A-Frame è pronto
  document.addEventListener('aframe-loaded', function() {
    initializeImageSync();
  });
  
  // Backup: inizializzazione quando 8th Wall è pronto
  document.addEventListener('xrextras-loaded', function() {
    initializeImageSync();
  });
  
  // Backup: inizializzazione periodica
  let retryCount = 0;
  const maxRetries = 10;
  const retryInterval = setInterval(() => {
    retryCount++;
    if (retryCount >= maxRetries) {
      clearInterval(retryInterval);
      return;
    }
    const scene = document.querySelector('a-scene');
    const targetImageOverlay = document.getElementById('targetImageOverlay');
    if (scene && targetImageOverlay) {
      clearInterval(retryInterval);
      initializeImageSync();
    }
  }, 1000);
  ` : ''}
</script>
<a-scene
  landing-page
  xrextras-loading
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrextras-loading
  xrweb="disableWorldTracking: true">

  <a-assets>
    <video id="video" ${thumbPath ? '' : 'autoplay muted'} crossorigin="anonymous" loop="true" src="${videoPath}"></video>
    ${imagePath ? `<img id="targetImage" src="${imagePath}" crossorigin="anonymous">` : ''}
    ${thumbPath ? `<img id="video-thumb" src="${thumbPath}" crossorigin="anonymous">` : ''}
  </a-assets>
  
  <a-camera
    position="${cameraPosition}"
    raycaster="objects: .cantap"
    cursor="fuse: false; rayOrigin: mouse;">
  </a-camera>
  
  <a-light type="ambient" intensity="${lightIntensity}"></a-light>
  
  <!-- Note: "name:" must be set to the name of the image target uploaded to the 8th Wall Console -->
  <xrextras-named-image-target name="${targetName}">
    ${thumbPath ?
      `<xrextras-target-video-sound 
        video="#video"
        thumb="#video-thumb"
        height="${videoHeight}"
        width="${videoWidth}"
        geometry="primitive: plane; width: ${videoWidth}; height: ${videoHeight}">
      </xrextras-target-video-sound>`
      : (videoHeight !== '1' || videoWidth !== '1') ?
        `<xrextras-target-video-fade 
          video="#video" 
          width="${videoWidth}" 
          height="${videoHeight}" 
          geometry="primitive: plane; width: ${videoWidth}; height: ${videoHeight}">
        </xrextras-target-video-fade>`
        :
        `<xrextras-target-video-fade video="#video"></xrextras-target-video-fade>`
    }
    

  </xrextras-named-image-target>
  
</a-scene>

`
}

// Template per esperienza AR multi-target
export const genericARmultiTemplate = (targets, videos, options = {}) => {
  const cameraPosition = options.cameraPosition || '0 4 10'
  const lightIntensity = options.lightIntensity || '1'
  const imagePath = options.imagePath || null
  const imageScale = options.imageScale || '1 1 1'
  const heights = options.heights || []
  const widths = options.widths || []
  const thumbs = options.thumbs || [] // Array di thumb paths per ogni video

  // Validazione input
  if (!Array.isArray(targets) || targets.length === 0) {
    console.error('❌ genericARmultiTemplate: targets deve essere un array non vuoto', targets)
    return `<div style="color: red; padding: 20px;">Errore: Nessun target configurato per l'esperienza AR multi-target</div>`
  }

  if (!Array.isArray(videos) || videos.length === 0) {
    console.error('❌ genericARmultiTemplate: videos deve essere un array non vuoto', videos)
    return `<div style="color: red; padding: 20px;">Errore: Nessun video configurato per l'esperienza AR multi-target</div>`
  }



  // Genera elementi <video> per ogni video (senza autoplay se ci sono thumb)
  const videoAssets = videos.map((video, index) => {
    if (!video || typeof video !== 'string') {
      console.warn('⚠️ Video non valido all\'indice', index, ':', video)
      return ''
    }

    const hasThumb = thumbs[index] && thumbs[index] !== null && thumbs[index] !== ''
    console.log(`🎥 DEBUG Video ${index}:`)
    console.log(`  - URL: ${video}`)
    console.log(`  - Thumb presente: ${!!thumbs[index]}`)
    console.log(`  - Thumb valore: "${thumbs[index]}"`)
    console.log(`  - hasThumb calcolato: ${hasThumb}`)
    console.log(`  - Attributi video: ${hasThumb ? 'NESSUN AUTOPLAY' : 'autoplay muted'}`)

    return `
    <video
      id="video${index}"
      preload="auto"
      ${hasThumb ? '' : 'autoplay muted'}
      loop="true"
      crossorigin="anonymous"
      webkit-playsinline
      playsinline>
      <source src="${video}" type="video/mp4">
    </video>`
  }).filter(asset => asset !== '').join('\n')

  // Genera elementi <img> per i thumb (solo se presenti)
  const thumbAssets = thumbs.map((thumb, index) => {
    if (!thumb || typeof thumb !== 'string' || thumb === '') {
      return ''
    }

    return `
    <img id="video-thumb${index}" src="${thumb}" crossorigin="anonymous">`
  }).filter(asset => asset !== '').join('\n')

  // Genera i target con i rispettivi video
  const targetElements = targets.map((target, index) => {
    if (!target || typeof target !== 'string') {
      console.warn('⚠️ Target non valido all\'indice', index, ':', target)
      return ''
    }

    if (index >= videos.length) {
      console.warn('⚠️ Nessun video corrispondente per il target', target, 'all\'indice', index)
      return ''
    }

    let videoHeight = heights || '1.0'
    let videoWidth = widths || '1.0'
    // Adjust videoHeight for venezia1/venezia2 targets
    if (target.includes('venezia1') || target.includes('venezia2')) {
      videoHeight = '1.06'
    }
    const hasThumb = thumbs[index] && thumbs[index] !== null && thumbs[index] !== ''

    console.log(`🎯 DEBUG Targets ${index}: "${target}"`)
    console.log(`  - Thumb[${index}]: "${thumbs[index]}"`)
    console.log(`  - hasThumb: ${hasThumb}`)
    console.log(`  - width: ${videoWidth}`)
    console.log(`  - height: ${videoHeight}`)
    console.log(`  - Componente usato: ${hasThumb ? 'xrextras-target-video-sound' : 'xrextras-target-video-fade'}`)

    return `
  <xrextras-named-image-target name="${target}">
    ${hasThumb ?
        `<xrextras-target-video-sound 
        video="#video${index}"
        thumb="#video-thumb${index}"
        height="${videoHeight}"
        width="${videoWidth}"
        geometry="primitive: plane; width: ${videoWidth}; height: ${videoHeight}">
      </xrextras-target-video-sound>`
        : `<xrextras-target-video-fade video="#video${index}" width="${videoWidth}" height="${videoHeight}"></xrextras-target-video-fade>`
      }
  </xrextras-named-image-target>`
  }).filter(element => element !== '').join('\n')

  // Debug output
  console.log('🎬 Assets video generati:', videoAssets.split('\n').length - 1)
  console.log('🎯 Target elements generati:', targetElements.split('\n').length - 1)

  return `

    <!-- Immagine al centro dello schermo che appare quando si incontra un target -->
    ${imagePath ? `
    <div 
      id="targetImageOverlay"
      class="target-image-overlay"
      style="
        position: fixed; 
        top: 50%; 
        left: 50%; 
        transform: translate(-50%, -50%); 
        width: 90vw; 
        height: auto; 
        max-width: none;
        z-index: 1000;
        display: block;
        pointer-events: none;
        -webkit-transform: translate(-50%, -50%);
        -webkit-user-select: none;
        -webkit-touch-callout: none;
      ">
      <img 
        src="${imagePath}" 
        style="
          width: 100%; 
          height: auto; 
          display: block;
          -webkit-user-select: none;
          -webkit-touch-callout: none;
        "
        crossorigin="anonymous"
        alt="Scan Image"
        onerror="console.error('❌ Errore caricamento immagine scan:', this.src)">
    </div>
    ` : ''}

    <script>
      // Funzioni per gestire la visibilità dell'immagine di scan
      const hideImage = () => {
        const targetImageOverlay = document.getElementById('targetImageOverlay');
        if (targetImageOverlay) {
          targetImageOverlay.style.display = 'none';
        }
        
        const scanElements = document.querySelectorAll('.scan-figure, .figura-scan, [id*="scan"], [class*="scan"]');
        scanElements.forEach(element => {
          if (element && element.style) {
            element.style.display = 'none';
            element.style.visibility = 'hidden';
            element.style.opacity = '0';
          }
        });
      };
      
      const showImage = () => {
        const targetImageOverlay = document.getElementById('targetImageOverlay');
        if (targetImageOverlay) {
          targetImageOverlay.style.display = 'block';
          
          const scanElements = document.querySelectorAll('.scan-figure, .figura-scan, [id*="scan"], [class*="scan"]');
          scanElements.forEach(element => {
            if (element && element.style) {
              element.style.display = 'block';
              element.style.visibility = 'visible';
              element.style.opacity = '1';
            }
          });
        }
      };

      // Tracciamento dei target attivi
      let activeTargets = new Set();

      // Inizializzazione sistema di monitoraggio
      document.addEventListener('DOMContentLoaded', function() {
        const scene = document.querySelector('a-scene');
        if (scene) {
          // Monitor eventi target trovati/persi
          scene.addEventListener('xrimagefound', function(event) {
            const targetName = event.detail.name;
            activeTargets.add(targetName);
            
            // Nascondi scan se c'è almeno un target attivo
            if (activeTargets.size > 0) {
              hideImage();
            }
          });
          
          scene.addEventListener('xrimagelost', function(event) {
            const targetName = event.detail.name;
            activeTargets.delete(targetName);
            
            // Mostra scan solo se non ci sono target attivi
            if (activeTargets.size === 0) {
              showImage();
            }
          });
        }
      });
    </script>

<a-scene 
  background="color: black"
  xrextras-almost-there
  xrextras-loading
  custom-qr-loading="splashImage: https://iscag-ei.it/wp-content/materiale/splashscreenarweb.png; showBackButton: false"
  xrextras-loading
  xrweb="disableWorldTracking: true">

  <a-assets>
  ${videoAssets}
  ${thumbAssets}
  </a-assets>

  <a-camera 
    id="camera"
    position="${cameraPosition}"
    raycaster="objects: .cantap"
    cursor="fuse: false; rayOrigin: mouse;">
  </a-camera>
  
  <a-light type="ambient" intensity="${lightIntensity}"></a-light>
  
  ${targetElements}
  
</a-scene>
`
}

// Funzione helper per ottenere informazioni del modello
export const getModelInfo = (modelType) => {
  const config = modelConfigs[modelType] || modelConfigs.generic
  return {
    title: config.title,
    description: config.description
  }
} 